import { end } from "@popperjs/core";
import { node } from "prop-types";

// QA URLs
// const superadminAPI = "https://qa-superadmin-api.clideanalyser.in";
// const mainUrl = "https://dev-api.clideanalyser.in";
// export const springUrl = "https://dev-api-spring.clideanalyser.in";
// export const stageUrl = "https://dev-admin-api.clideanalyser.in";
// const nodeUrl = "https://dev-api-node.clideanalyser.in/api/v1";
// const springUrl = "http://localhost:8081/ClideAppSpring";
//const springUrl = "http://localhost:8081/ClideAppSpring";
// const stageUrl = "http://localhost:8084/AdminSpring";
// const nodeUrl = "https://dev-api-node.clideanalyser.in/api/v1/";

// QA node url

// local node url
// const nodeUrl = "http://localhost:5000/api/v1";
//  const nodeUrl = "https://qa-clide-api-node.clideanalyser.in/api/v1";
//  const nodeUrl = "https://dev-api-node.clideanalyser.in/api/v1";
// const nodeUrl = "https://dev-api-node.clideanalyser.in/api/v1";
// local node url
//  const nodeUrl = "https://qa-clide-api-node.clideanalyser.in/api/v1";
// const nodeUrl = "https://dev-api-node.clideanalyser.in/api/v1";

// stage URLs

//localhost
// const mainUrl = "http://localhost:8080/ClideApp";
//const nodeLocalUrl = "http://localhost:5000/api/v1";
// Springboot Stage
// const superadminAPI = "https://stage-superadmin-api.clideanalyser.in";
// const mainUrl = "https://stage-api.clideanalyser.in";
// export const springUrl = "https://stage-api-spring.clideanalyser.in";
// export const stageUrl = "https://stage-admin-api.clideanalyser.in"
// const nodeUrl = "https://stage-api-node.clideanalyser.in/api/v1";
//const springUrl = "http://localhost:8081";

//const springUrl = "https://localhost:3000/ClideApp";

// //Production Urlgi
const mainUrl = "https://clide-api.clideanalyser.in";
const superadminAPI = "https://superadmin-api.clideanalyser.in";
export const stageUrl = "https://clide-admin-api.clideanalyser.in";
export const springUrl = "https://clide-api-spring.clideanalyser.in";
const nodeUrl = "https://clide-api-node.clideanalyser.in/api/v1";

//Production Urlgi
// const mainUrl = "https://clide-api.clideanalyser.in";
// const superadminAPI = "https://superadmin-api.clideanalyser.in";

// const constURL = "https://qa-superadmin-api.clideoffice.com/myresource/";

//britannia env urls for production
// const mainUrl = "https://clide-api.britindia.com/ClideApp";
// const superadminAPI = "https://clidedb.britindia.com";
// const springUrl = "https://clide-api.britindia.com/ClideAppSpring";
// const stageUrl = "https://clide-api.britindia.com/AdminSpring";

//britannia env urls for qa
// const mainUrl = "https://qaclide-api.britindia.com/ClideApp";
// const superadminAPI = "https://qa-superadmin-api.clideanalyser.in";
// const superadminAPI = "https://stage-superadmin-api.clideanalyser.in";
// const springUrl = "https://qaclide-api.britindia.com/ClideAppSpring";
// const stageUrl = "https://qaclide-api.britindia.com/AdminSpring";

//ChatBot URL
const MainChatBotURL = "http://localhost:8000/api";

const urls = {
  clientURL: mainUrl,
  springClientURL: springUrl,
  nodeClientURL: nodeUrl,
  login: `${mainUrl}/user/loginn`,
  springLogin: `${springUrl}/auth/login`,
  ssoExchange: `${mainUrl}/sso/exchange`,
  ssoLogin: `${mainUrl}/sso/login`,
  superAdminURL: superadminAPI,
  calendar: `${springUrl}/module/calendar`,
  // SSO Admin Configuration (Spring Boot / stageUrl)
  sso: {
    spDetails: `${stageUrl}/sso/sp-details`,
    config: `${stageUrl}/sso/config`,
    saveConfig: `${stageUrl}/sso/config/save`,
    uploadXml: `${stageUrl}/sso/config/upload-xml`,
    loginType: `${stageUrl}/sso/config/login-type`,
  },
  changePassword: `${mainUrl}/user/changepassword`,
  forgotPassword: `${mainUrl}/user/forgetpassword`,
  otpverification: `${mainUrl}/user/otpverification`,
  resendOtp: `${mainUrl}/user/resendOtp`,
  otpGenerateReset: `${mainUrl}/user/otp_generate_reset_password`,
  usersList: `${springUrl}/user/details`,
  userSearch: `${springUrl}/user/activeUserSearch`,
  searchTopic: `${springUrl}/training/topicList`,
  externalUserSearch: `${mainUrl}/master/externalusersearch`,
  setPassword: `${mainUrl}/user/setpassword`,
  linkExpire: `${mainUrl}/user/linkexpirecheck`,
  resendLink: `${mainUrl}/user/resendlink`,
  profile: `${mainUrl}/user/profile`,
  reportingTeam: `${stageUrl}/employee/reportingTeam`,
  designation: `${mainUrl}/user/userdesignationlist`,
  compnayLogo: `${mainUrl}/user/companylogo`,
  loginPageSettings: `${stageUrl}/loginPage/getSetting`,
  hTriangle: `${mainUrl}/htriangle/list`,
  notification: `${mainUrl}/notification`,
  notificationNo: `${mainUrl}/notification/notificationNumber`,
  notificationRead: `${mainUrl}/notification/notificationStatus`,
  notificationSticky: `${mainUrl}/notification/getlatestrecentUpdate`,
  notificationStickyClose: `${mainUrl}/notification/closeRecentUpdate`,
  communicationNotification: `${superadminAPI}/recentUpdate/getpublishrecentUpdate`,
  loginPageContent: `${superadminAPI}/common/viewindexgif`,
  tagLine: `${superadminAPI}/index/tagline`,
  // AdminSpring login page settings
  loginPageEditSetting: `${stageUrl}/loginPage/editSetting`,
  loginPageGetSetting: `${stageUrl}/loginPage/getSetting`,
  loginPagePermissionByDb: `${superadminAPI}/setting/getLoginPagePermissionByDb`,
  loginPageCarouselSave: `${stageUrl}/loginPage/carousel/save`,
  loginPageCarouselDelete: `${stageUrl}/loginPage/carousel/delete`,
  editprofile: `${mainUrl}/user/editprofile`,
  safetyChampion: `${mainUrl}/sm/safetychampian`,
  safetyChampionFilter: `${mainUrl}/sm/filtersafetychampian`,
  userwisedata: `${mainUrl}/user/userwisedata`,
  employeeWiseReportingTrends: `${springUrl}/graph/employwisereporting`,
  employeeCloserTrends: `${springUrl}/graph/userwisecloserrange`,
  plantRolePerformance: `${springUrl}/graph/plantroleperformance`,
  userwisedataexcel: `${mainUrl}/user/userwisedataexcel`,
  adminActivateUser: `${stageUrl}/userMaster/activateuser`,
  adminMakeActiveUser: `${stageUrl}/employee/makeActiveUser`,
  allModulesCount: {
    lastTwoDaysCount: `${mainUrl}/allmodulescount/lasttwodayscount`,
    monthwisecount: `${mainUrl}/allmodulescount/monthwisecount`,
    openNumbers: `${mainUrl}/allmodulescount/opennumbers`,
    numbers: `${mainUrl}/allmodulescount/numbers`,
    target: `${mainUrl}/soidashboard/bscannualtarget`,
  },
  adminResendForgotPasswordMail: `${mainUrl}/adminservice/resendemailforpassword`,
  adminprofile: `${mainUrl}/adminprofile/adminprofiledetails`,
  editAdminProfile: `${mainUrl}/adminprofile/editadminprofile`,
  adminChangePassword: `${mainUrl}/adminprofile/adminchangepassword`,
  activityDetailSpring: `${springUrl}/adminhiraact/getByActivity`,
  activityDetail: `${mainUrl}/adminhiraact/getByActivity`,
  riskRegisterByActivity: `${springUrl}/riskRegister/getByActivity`,
  organisationSettingByDb: `${superadminAPI}/setting/getOrganisationSettingByDb`,
  workingDay: `${stageUrl}/workingDay/list`,
  workingDayUpdate: `${stageUrl}/workingDay/update`,
  globalFilterList: `${springUrl}/service/compserprojectlist`,
  clientMaster: {
    cmList: `${stageUrl}/ppc/list`,
    cmAdd: `${stageUrl}/ppc/create`,
    cmDetail: `${stageUrl}/ppc/detail`,
    cmUpdate: `${stageUrl}/ppc/update`,
    cmDelete: `${stageUrl}/ppc/delete`,
    cmUpload: `${stageUrl}/ppc/importExcelCsv`,
    cmExport: `${stageUrl}/ppc/exportExcelCsv`,
    cmRestore: `${stageUrl}/ppc/restore`,
  },
  contractorMaster: {
    cmList: `${stageUrl}/contractor/list`,
    cmAdd: `${stageUrl}/contractor/create`,
    cmDetail: `${stageUrl}/ppc/detail`,
    cmUpdate: `${stageUrl}/contractor/update`,
    cmDelete: `${stageUrl}/contractor/delete`,
    cmUpload: `${stageUrl}/contractor/importExcelCsv`,
    cmExport: `${stageUrl}/contractor/exportExcelCsv`,
    cmRestore: `${stageUrl}/contractor/restore`,
  },
  costMaster: {
    costList: `${stageUrl}/costMaster/fetchByDepth`,
    costConfig: `${stageUrl}/costMaster/configure`,
    costTypeAdd: `${stageUrl}/costMaster/costType/create`,
    cosTypeDelete: `${stageUrl}/costMaster/costType/delete`,
    cosTypeComponentAdd: `${stageUrl}/costMaster/costComponent/create`,
    cosTypeCategoryAdd: `${stageUrl}/costMaster/costCategory/create`,
    costComponentDelete: `${stageUrl}/costMaster/costComponent/delete`,
    costCategoryDelete: `${stageUrl}/costMaster/costCategory/delete`,
    costTypeUpdate: `${stageUrl}/costMaster/costType/update`,
    costComponentUpdate: `${stageUrl}/costMaster/costComponent/update`,
    costCategoryUpdate: `${stageUrl}/costMaster/costCategory/update`,
    costFetchDepth: `${stageUrl}/costMaster/fetchDepth`,
    costDataNm: `${springUrl}/costReport/costReportDetails`,
    costDataUpdateNm: `${springUrl}/costReport/updateCostReport`,
    unitUpdate: `${stageUrl}/costMaster/unit/update`,
    unitListMaster: `${stageUrl}/costMaster/unit/list`,
    addUnitListMaster: `${stageUrl}/costMaster/unit/create`,
    deleteUnitListMaster: `${stageUrl}/costMaster/unit/delete`,
    unitList: `${springUrl}/costReport/unitList`,
  },
  lmsDashboard: {
    getLearnerDashboardData: `${springUrl}/course/dashboard/learnerDashboardStats`,
    getAdminDashboardData: `${springUrl}/course/dashboard/adminDashboardStats`,
  },
  lmsCourse: {
    createCourse: `${springUrl}/course/create`,
    uploadFile: `${springUrl}/course/uploadFile`,
    allCourses: `${springUrl}/course/all_list`,
    coursesList: `${springUrl}/course/list`,
    getCourseById: `${springUrl}/course/detail`,
    addReview: `${springUrl}/review/add`,
    updateReview: `${springUrl}/review/update`,
    startQuiz: `${springUrl}/quiz/start`,
    submitQuiz: `${springUrl}/quiz/submit`,
    resultQuiz: `${springUrl}/quiz/result`,
    weeklySchedule: `${springUrl}/course/generate-weekly-reminder`,
    likeAttachment: `${springUrl}/course/content/like`,
    attachmentStatus: `${springUrl}/course/attachment-access/manage`,
    contentStatus: `${springUrl}/course/content/progress/manage`,
    courseStatus: `${springUrl}/course/progress/manage`,
    watchingStats: `${springUrl}/course/watching/stats`,
    quizDetail: `${springUrl}/quiz/detail?`,
    sectionDetail: `${springUrl}/course/section/details`,
    reviewGetData: `${springUrl}/review/getData`,
    statisticsGetData: `${springUrl}/statistics/getData`,
    // Admin dashboard stats for admin cards
    adminStats: `${springUrl}/course/dashboard/adminStats`,
    adminEnrollmentTrend: `${springUrl}/course/dashboard/adminEnrollmentTrend`,
    adminCourseInsights: `${springUrl}/course/dashboard/adminCourseInsights`,
    timelineStats: `${springUrl}/course/progress/stats`,
    learnerProgress: `${springUrl}/course/learner/progress`,
    deleteLearner: `${springUrl}/course/deleteLearner`,
    getMessageSettings: `${springUrl}/course/mailSetting`,
  },
  // Admin Spring LMS endpoints
  lms: {
    editMailSettingConfig: `${stageUrl}/lms/editMailSettingConfig`,
    mailSettingConfig: `${stageUrl}/lms/mailSettingConfig`,
  },
  // Admin Spring UAUC mail configuration endpoints
  uauc: {
    mailSettingConfig: `${stageUrl}/module/mailConfiguration`,
    editMailSettingConfig: `${stageUrl}/module/mailConfiguration`,
  },
  lmsLesson: {
    addSection: `${springUrl}/course/lesson/addSection`,
    addContent: `${springUrl}/lesson/addSectionContent`,
    tagList: `${stageUrl}/tagMaster/tagList`,
    categoryList: `${stageUrl}/categoryMaster/categoryList`,
    categoryLevel: `${stageUrl}/courseMaster/courseList`,
    langList: `${stageUrl}/languageMaster/languageList`,
    sectionList: `${springUrl}/course/section/list`,
    deleteSection: `${springUrl}/course/section/delete`,
    deleteContent: `${springUrl}/course/content/delete`,
    // learnerlist: `${springUrl}/user/getAllActiveUser`,
    learnerlist: `${springUrl}/course/getAllActiveUserWithStatistics`,
    selectedlearnerlist: `${springUrl}/course/getAllAssignUserWithStatistics`,
    lockUnlockContent: `${springUrl}/course/content/lockUnlock`,
    assignUnassignAllLearnerToCourse: `${springUrl}/course/assignUnassignAllLearnerToCourse`,
    assignUnassignListOfLearnerToCourse: `${springUrl}/course/assignUnassignListOfLearnerToCourse`,
    generateSampleExcelCsv: `${springUrl}/course/generateSampleExcelCsv`,
    importAssignLearners: `${springUrl}/course/importAssignLearners`,
  },
  lmsAssessment: {
    addPreTest: `${springUrl}/assessment/create`,
    getPreTestById: `${springUrl}/assessment/details`,
    updatePreTest: `${springUrl}/assessment/update`,
    addSection: `${springUrl}/assessment/section/add`,
    updateSection: `${springUrl}/assessment/section/update`,
    DeleteSection: `${springUrl}/assessment/section/delete`,
    addQuestion: `${springUrl}/assessment/question/add`,
    updateQuestion: `${springUrl}/assessment/question/update`,
    deleteQuestion: `${springUrl}/assessment/question/delete`,
    sectionList: `${springUrl}/assessment/section/list`,
    assessmentList: `${springUrl}/assessment/list`,
    deleteAssessment: `${springUrl}/assessment/delete`,
    publish: `${springUrl}/assessment/publish`,
    questionBank: `${springUrl}/assessment/questionBank`,
    addQuestionsToAssessment: `${springUrl}/assessment/question/import`,
    makeFinal: `${springUrl}/assessment/makeFinal`,
    copyQuestion: `${springUrl}/assessment/question/copy`,
    copySection: `${springUrl}/assessment/section/copy`,
    display: `${springUrl}/assessment/display`,
    start: `${springUrl}/assessment/start`,
    submit: `${springUrl}/assessment/submit`,
    fetchCertificateSettings: `${springUrl}/certificate/getSetting`,
    editCertificateSetting: `${springUrl}/certificate/editSetting`,
  },
  chatBot: {
    startSession: `${MainChatBotURL}/session/start`,
    endSession: `${MainChatBotURL}/session/end`,
    chat: `${MainChatBotURL}/chat`,
  },

  EmployeeMaster: {
    emList: `${stageUrl}/employee/list`,
    employeeSearch: `${stageUrl}/employee/serachEmployee`,
    emAdd: `${stageUrl}/employee/create`,
    emDetail: `${stageUrl}/employee/detail`,
    emUploadcsv: `${stageUrl}/employee/importExcelCsv`,
    emExport: `${stageUrl}/employee/exportExcelCsv`,
    generateSampleExcelCsv: `${stageUrl}/employee/generateSampleExcelCsv`,
    generateSampleExcelCsvNew: `${stageUrl}/ohsms/generateSampleExcelCsv`,
    emUpdate: `${stageUrl}/employee/update`,
    emDelete: `${stageUrl}/employee/delete`,
    getSetting: `${stageUrl}/employee/settingData`,
    saveSetting: `${stageUrl}/employee/editSettingData`,
    uploadEmpHierarchy: `${stageUrl}/employee/importReportingExcelCsv`,
    downloadSampleEmpHierarchy: `${stageUrl}/employee/generateReportingSampleExcelCsv`,
  },

  bscReport: {
    bscReportRight: `${mainUrl}/bscreport/bscmodulerights`,
    serviceBasedUserList: `${mainUrl}/bscreport/bscuserrightlist`,
    assignUser: `${mainUrl}/bscreport/addbscuserrights`,
    removeUser: `${mainUrl}/bscreport/deletebscuserrights`,
    bsc: {
      yearList: `${mainUrl}/bscreport/bscreportyearlist`,
      misListing: `${mainUrl}/bscreport/listbscmiscount`,
      leadingListing: `${mainUrl}/bscreport/listallmonthbscreportleadcount`,
      leadingGraphListing: `${mainUrl}/bscreport/bscleadingIndicatorGraphCounts`,
      laggingListing: `${mainUrl}/bscreport/listallmonthbscreportlaggingcount`,
      laggingGraphListing: `${mainUrl}/bscreport/bsclaggingIndicatorGraphCounts`,
      monthList: `${mainUrl}/bscreport/bsctabmonthoptionlist`,
      overallMonthList: `${mainUrl}/bscreport/overallgraphfilterlist`,
      overallGraphList: `${mainUrl}/bscreport/bscleadlagoverallgraphcounts`,
      monthleadingListing: `${mainUrl}/bscreport/bscleadcountmonthwisedetails`,
      monthlaggingListing: `${mainUrl}/bscreport/bsclagcountmonthwisedetails`,
    },
    kpi: {
      yearList: `${mainUrl}/bscreport/kpiyearlist`,
      misListing: `${mainUrl}/bscreport/listkpimiscount`,
      leadingListing: `${mainUrl}/bscreport/listkpileadingindicator`,
      laggingListing: `${mainUrl}/bscreport/listkpilaggingindicator`,
    },
  },
  ohsms: {
    reportRight: `${mainUrl}/master/rightslist`,
    serviceBasedUserList: `${mainUrl}/master/rightslist`,
    assignUser: `${mainUrl}/bscreport/addbscuserrights`,
    removeUser: `${mainUrl}/bscreport/deletebscuserrights`,
    addToProject: `${springUrl}/riskRegister/addToProject`,
    addToProjectBulk: `${springUrl}/riskRegister/addToProjectBulk`,
    fetchadminconfiguration: `${stageUrl}/fetchadminconfiguration`,
    fetchAdminConfiguration: `${stageUrl}/fetchadminconfiguration`,
    editadminconfiguration: `${stageUrl}/editadminconfiguration`,
    editAdminConfiguration: `${stageUrl}/editadminconfiguration`,
  },
  mis: {
    uploadStatusList: `${springUrl}/mis/uploadStatus/list`,
    yearsFilterList: `${mainUrl}/misreport/yearfilteroptionlist`,
    serviceBasedUserList: `${mainUrl}/misreport/misuserrightlist`,
    assignUser: `${mainUrl}/misreport/addmisuserrights`,
    removeUser: `${mainUrl}/misreport/deletemisuserrights`,
    admin: {
      workflow: {
        misFormConfigurationEdit: `${mainUrl}/misadminvalues/misuseralloweddurationedit`,
        misFormConfigurationList: `${mainUrl}/misadminvalues/misuseralloweddurationlist`,
      },
      fetchApprovalConfiguration: `${stageUrl}/fetchApprovalConfiguration`,
      editApprovalConfiguration: `${stageUrl}/editApprovalConfiguration`,
    },
    misUserAllowedDurationEdit: `${springUrl}/mis/misuseralloweddurationedi`,
    misUserAllowedDurationList: `${springUrl}/mis/misuseralloweddurationlist`,
    approvalStatusTimeline: `${springUrl}/mis/approvalStatus`,
    misGetGenericTable: `${springUrl}/mis/importExcelCsv`,
    importExcelCsvProjectwise: `${springUrl}/mis/importExcelCsvProjectwise`,
    importSectionExcelCsv: `${springUrl}/mis/importSectionExcelCsv`,
    misSampleExcelCsv: `${springUrl}/mis/generateSampleExcelCsv`,
    exportExcelCsv: `${springUrl}/mis/exportExcelCsv`,
    deleteTableData: `${springUrl}/mis/deletetable`,
    getGeneralData: `${springUrl}/mis/getGeneralData`,
    getGeneralMonthList: `${springUrl}/mis/columnlist`,
    addColumnData: `${springUrl}/mis/addupdatecolumnvalue`,
    editGeneralData: `${springUrl}/mis/editGeneralData`,
    addRowData: `${springUrl}/mis/addfield`,
    fetchUnits: `${springUrl}/mis/unitlist`,
    approveReject: `${springUrl}/mis/approveReject`,
    addEvidence: `${springUrl}/mis/addEvidence`,
    deleteEvidence: `${springUrl}/mis/deleteEvidence`,
    updateRowStatus: `${springUrl}/mis/updateRowStatus`,
    Esg: {
      misGetGenericTable: `${springUrl}/misesg/importExcelCsv`,
      importExcelCsvProjectwise: `${springUrl}/misesg/importExcelCsvProjectwise`,
      importSectionExcelCsv: `${springUrl}/misesg/importSectionExcelCsv`,
      misSampleExcelCsv: `${springUrl}/misesg/generateSampleExcelCsv`,
      exportExcelCsv: `${springUrl}/misesg/exportExcelCsv`,
      deleteTableData: `${springUrl}/misesg/deletetable`,
      getGeneralData: `${springUrl}/misesg/getData`,
      getGeneralMonthList: `${springUrl}/misesg/columnlist`,
      addColumnData: `${springUrl}/misesg/addupdatecolumnvalue`,
      editGeneralData: `${springUrl}/misesg/editEsgData`,
      addRowData: `${springUrl}/misesg/addfield`,
      fetchUnits: `${springUrl}/misesg/unitlist`,
      approveReject: `${springUrl}/mis/approveReject`,
      updateRowStatus: `${springUrl}/misesg/updateRowStatus`,
      addScopeRow: `${springUrl}/misesg/addScopeRow`,
      emissionDashboard: `${springUrl}/misesg/emissionDashboard`,
      emissionCalculation: `${springUrl}/misesg/emissionCalculation`,
      topEmissionSources: `${springUrl}/misesg/emissionDashboard/topEmissionSources`,
    },
    manpowerTab: {
      averageManpowerTraferList: `${mainUrl}/misreport/listaveragemanpowercount`,
      averageManpowerRefreshList: `${mainUrl}/misreport/refreshaveragemanpowercount`,
      manpowerList: `${mainUrl}/misreport/listmanpowercount`,
      manpowerEdit: `${mainUrl}/misreport/editmanpowercount`,
      manhoursList: `${mainUrl}/misreport/listmanhours`,
      manhourEdit: `${mainUrl}/misreport/editmanhours`,
      equpimentList: `${mainUrl}/misreport/listequipmentareacount`,
      equpimentEdit: `${mainUrl}/misreport/editequipmentareacount`,
    },
    bscLeadingTab: {
      yearsFilterList: `${mainUrl}/misreport/leadingyearoptionlist`,
      actionList: `${mainUrl}/misreport/listleadingactioncount`,
      actionEdit: `${mainUrl}/misreport/editleadingactioncount`,
      appreciationList: `${mainUrl}/misreport/listleadingappreciationscount`,
      appreciationEdit: `${mainUrl}/misreport/editleadingappreciationscount`,
      awardsList: `${mainUrl}/misreport/listleadingawardscount`,
      awardsEdit: `${mainUrl}/misreport/editleadingawardscount`,
      eventsList: `${mainUrl}/misreport/listleadingeventscount`,
      eventsEdit: `${mainUrl}/misreport/editleadingeventscount`,
      kaizenList: `${mainUrl}/misreport/listleadingkaizencount`,
      kaizenEdit: `${mainUrl}/misreport/editleadingkaizencount`,
      trainingList: `${mainUrl}/misreport/listleadingtrainingcount`,
      trainingEdit: `${mainUrl}/misreport/editleadingtrainingcount`,
      reviewList: `${mainUrl}/misreport/listleadingreviewcount`,
      reviewEdit: `${mainUrl}/misreport/editleadingreviewcount`,
      auditList: `${mainUrl}/misreport/listleadingauditcount`,
      auditEdit: `${mainUrl}/misreport/editleadingauditcount`,
      inspectionList: `${mainUrl}/misreport/listleadinginspectioncount`,
      inspectionEdit: `${mainUrl}/misreport/editleadinginspectioncount`,
      deviationList: `${mainUrl}/misreport/listleadingdeviationcount`,
      capaList: `${mainUrl}/misreport/listbscleadcapacount`,
      sourceList: `${mainUrl}/misreport/listleadingindicatorcount`,
    },
    bsLaggingTab: {
      yearsFilterList: `${mainUrl}/misreport/laggingyearoptionlist`,
      laggingList: `${mainUrl}/misreport/listlaggingindicatorcount`,
      laggingInputList: `${mainUrl}/misreport/listlaggingcount`,
      laggindEdit: `${mainUrl}/misreport/editlaggingcount`,
    },
    analysis: {
      parameterList: `${mainUrl}/misreport/listmisanalysis`,
      parameterRefreshList: `${mainUrl}/misreport/refreshmisanalysiscount`,
      yearsFilterList: `${mainUrl}/misreport/misanalysisyearoptionlist`,
    },
  },
  smDashboard: {
    reportFeeds: `${mainUrl}/sm/dashboardcontent`,
    resolveSOI: `${mainUrl}/sm/dashboardcontentresolvesoi`,
    uaucresolveSOI: `${springUrl}/uauc/resolve`,
    removeInviteUser: `${mainUrl}/sm/dashboarddetailsoiremoveinvitee`,
    uaucRemoveInviteUser: `${springUrl}/uauc/dashboarddetailsoiremoveinvitee`,
    addInviteUser: `${mainUrl}/sm/dashboarddetailsoiaddinvitee`,
    uaucaddInviteUser: `${springUrl}/uauc/dashboarddetailsoiaddinvitee`,
    inviteUserList: `${mainUrl}/sm/dashboarddetailinviteeuserlist`,
    uaucinviteUserList: `${springUrl}/uauc/addUserList`,
    otherDashboardDetails: `${mainUrl}/sm/dashboardHeader`,
    addSafetyThought: `${springUrl}/safetythought/dashboardcontentaddsafetythought`,
    editSafetyThought: `${springUrl}/safetythought/edit`,
    deleteSafetyThought: `${springUrl}/safetythought/dashboardcontentremovesafetythought`,
    safetyThoughtSettingEdit: `${stageUrl}/safetythought/editSettingData`,
    getSafetyThoughtSetting: `${stageUrl}/safetythought/settingData`,
    generateSafetyThoughtQR: `${stageUrl}/master/generateqr`,
    editSafetyThoughtQR: `${stageUrl}/master/editqr`,
    externalSafetyThoughtReport: `${springUrl}/safetythought/externalthought`,
    likeReport: `${mainUrl}/sm/dashboardcontentaddlike`,
    removeLikeReport: `${mainUrl}/sm/dashboardcontentremovelike`,
    socialMediaFilter: `${mainUrl}/sm/dashboardcontentmodulefilter`,
    socialMediaFilterPersonal: `${mainUrl}/sm/dashboardcontentmodulefilterpersonal`,
    socialMediaSafetyThoughtFilter: `${mainUrl}/sm/dashboardcontentstfilter`,
    getCommentsList: `${mainUrl}/sm/dashboarddetailcommentlist`,
    addMainComment: `${mainUrl}/sm/dashboardcontentaddcomment`,
    replyToComment: `${mainUrl}/sm/dashboardcontentaddsubcomment`,
    addLikeToComment: `${mainUrl}/sm/dashboardcontentaddliketocomment`,
    dashboarddetailcommentsubcommentlist: `${mainUrl}/sm/dashboarddetailcommentsubcommentlist`,
    dashboardcontentcommentremoveunlike: `${mainUrl}/sm/dashboardcontentcommentremoveunlike`,
    dashboarddetaillikelist: `${mainUrl}/sm/dashboarddetaillikelist`,
  },
  soiDashboard: {
    openResolveNumber: `${mainUrl}/statsoi/soinumber`,
    openList: `${mainUrl}/listSoi/soiopenlistweb`,
    resolveList: `${mainUrl}/listSoi/soiresolvelistweb`,
    openListProject: `${mainUrl}/listSoi/soiopenlistwebproject`,
    uaucOpenListProject: `${springUrl}/uauc/list`,
    statsCount: `${springUrl}/uauc/stats-count`,
    // openListProject: `${mainUrl}/listSoi/soiopenlistwebprojectnew`,
    resolveListProject: `${mainUrl}/listSoi/soiresolvelistwebproject`,
    springresolveListProject: `${springUrl}/uauc/list`,

    // resolveListProject: `${mainUrl}/listSoi/soiresolvelistwebprojectnew`,
    openDetailList: `${mainUrl}/listSoi/soiopendetail`,
    uaucOpenDetailList: `${springUrl}/uauc/soiopendetail`,
    resolveDetailList: `${mainUrl}/listSoi/soiresolvedetail`,
    springresolveDetailList: `${springUrl}/uauc/soiresolvedetail`,
    soiOpenTransferList: `${mainUrl}/listSoi/soiopentransferlistweb`,
    serviceProjectList: `${mainUrl}/service/serviceprojectlist`,
    springServiceProjectList: `${springUrl}/service/serviceprojectlist`,
    dashboardNumbers: `${mainUrl}/statsoi/soidashboardnumber`,
    dashboard: {
      stats: `${mainUrl}/soidashboard/stat`,
      trendsGraphs: `${springUrl}/uauc/trends`,
      statProject: `${springUrl}/uauc/statproject`,
      dashboardNumber: `${mainUrl}/statsoi/soidashboardnumberproject`,
      zoneRights: `${mainUrl}/soidashboard/zonerights`,
      uaucGraphs: `${springUrl}/uauc/uaanducseperategraphproject`,
    },
    isReviewProject: `${stageUrl}/uauc/isreview`,
    postReview: {
      approveReject: `${springUrl}/uauc/approveReject`,
      categoryList: `${stageUrl}/uaucCategory/dropdown`,
    },
    escalationList: `${mainUrl}/project/soiescalationlist`,
    closingRights: `${mainUrl}/project/soiclosingrightlist`,
    soiSearch: `${mainUrl}/listSoi/soiopensearch`,
    springsoiSearch: `${springUrl}/uauc/list`,
    soiResolveSearch: `${mainUrl}/listSoi/soiresolvesearch`,
    soideletecomment: `${mainUrl}/listSoi/soideletecomment`,
    soiopendelete: `${mainUrl}/listSoi/soiopendelete`,
    uaucsoiopendelete: `${springUrl}/uauc/delete`,
    uaucStatusUpdate: `${springUrl}/uauc/updateStatus`,
    openEdit: `${mainUrl}/listSoi/soiedit`,
    uaucopenEdit: `${springUrl}/uauc/reportEdit`,
    soiOpenOpenSearchResolve: `${mainUrl}/listSoi/soiopensearchforresolve`,
    soiexceloverall: `${mainUrl}/listSoi/soiexceloverall`,
    springsoiexceloverall: `${springUrl}/uauc/excelDownload`,
    soiexceloverallresolve: `${mainUrl}/listSoi/soiexceloverallresolve`,
    escalatedList: `${springUrl}/uauc/escalatedlist`,
    deleteControlMeasure: `${mainUrl}/listSoi/deletesoicontrolmeasure`,
    soiOpenListDateSort: `${mainUrl}/listSoi/soiopenlistdatesort`,
    soiDashboardAnalysis: `${mainUrl}/statsoi/soidashboardanalysis`,
    soiDashboardAnalysisProject: `${mainUrl}/statsoi/soidashboardanalysisproject`,
    reports: {
      ppcReport: `${springUrl}/graph/count`,
      riskReport: `${springUrl}/graph/risklevelcount`,
      ppcReportExcel: `${springUrl}/graph/countexcelDownload`,
      riskReportExcel: `${springUrl}/graph/risklevelcountexcelDownload`,
      depatmentReport: `${springUrl}/graph/uaucdepartmentcount`,
      riskDepartmentReport: `${springUrl}/graph/uaucriskdepartment`,
      departmentReportExcel: `${springUrl}/graph/uaucdepartmentexcelDownload`,
      riskDepartmentReportExcel: `${springUrl}/graph/uaucRiskleveldepartmentexcelDownload`,
      hazardReport: `${springUrl}/graph/uaucHazardcount`,
      riskHazardReport: `${springUrl}/graph/uaucriskHazard`,
      hazardReportExcel: `${springUrl}/graph/uaucHazardexcelDownload`,
      riskHazardReportExcel: `${springUrl}/graph/uaucRisklevelhazardexcelDownload`,
      sourceReport: `${springUrl}/graph/uaucsourcecount`,
      riskSourceReport: `${springUrl}/graph/uaucrisksource`,
      sourceReportExcel: `${springUrl}/graph/uaucsourceexcel`,
      riskSourceReportExcel: `${springUrl}/graph/uaucrisklevelsourceexcel`,
      contractorReport: `${springUrl}/graph/uauccontractorcount`,
      riskContractorReport: `${springUrl}/graph/uaucriskcontractor`,
      contractorReportExcel: `${springUrl}/graph/uauccontractorexcel`,
      riskContractorReportExcel: `${springUrl}/graph/uaucrisklevelcontractorexcel`,
      designationReport: `${springUrl}/graph/uaucdesignationcount`,
      riskDesignationReport: `${springUrl}/graph/uaucriskdesignation`,
      designationReportExcel: `${springUrl}/graph/uaucdesignationexcel`,
      riskDesignationReportExcel: `${springUrl}/graph/uaucriskleveldesignationexcel`,
      escalationReport: `${springUrl}/graph/escalation`,
      escalationRiskReport: `${springUrl}/graph/escalationrisklevel`,
      escalationReportExcel: `${springUrl}/graph/escalationexceldownload`,
      escalationRiskReportExcel: `${springUrl}/graph/escalationrisklevelexceldownload`,
      riskTrendReport: `${springUrl}/graph/risklevel`,
      riskTrendReportExcel: `${springUrl}/graph/risklevelexceldownload`,
      tatByRiskReport: `${springUrl}/graph/avgtatrisklevel`,
      tatByRiskReportExcel: `${springUrl}/graph/avgtatrisklevelexceldownload`,
      agingRiskReport: `${springUrl}/graph/avgageingrisklevel`,
      agingRiskReportExcel: `${springUrl}/graph/avgageingrisklevelexceldownload`,
    },
  },
  reviewCategory: {
    categoryList: `${stageUrl}/uaucCategory/list`,
    deleteCategory: `${stageUrl}/uaucCategory/delete`,
    createCategory: `${stageUrl}/uaucCategory/create`,
    updateCategory: `${stageUrl}/uaucCategory/update`,
    importCategory: `${stageUrl}/uaucCategory/import`,
    exportCategory: `${stageUrl}/uaucCategory/export`,
    restoreCategory: `${stageUrl}/uaucCategory/restore`,
  },
  summary: {
    summary: `${mainUrl}/summary/allsummary`,
    zoneList: `${mainUrl}/project/zonelist`,
    departmentList: `${mainUrl}/project/pdeptlist`,
    contractorList: `${mainUrl}/project/pconlist`,
    safetyTeamList: `${mainUrl}/project/psafetylist`,
    activityList: `${mainUrl}/project/pactivitylist`,
    barrierList: `${mainUrl}/project/pbarrierlist`,
    hazardList: `${mainUrl}/project/phazardlist`,
    formParameterList: `${mainUrl}/project/soiformparameterlist`,
    uaucformParameterList: `${stageUrl}/uauc/settingData`,
    formParameterEdit: `${mainUrl}/project/soiformparameteredit`,
    uaucformParameterEdit: `${stageUrl}/uauc/editSettingData`,
    userList: `${mainUrl}/project/userlist`,
    allmodulescount: `${mainUrl}/allmodulescount/monthwisecount/`,
    financialCosting: `${mainUrl}/summary/financialcosting`,
    workflowConfig: `${stageUrl}/uauc/getWorkflow`,
    upadateWorkflowConfig: `${stageUrl}/uauc/setWorkflow`,
    getUserListBySubStream: `${stageUrl}/uauc/getUserListBySubStream`,
    observerSettingEdit: `${stageUrl}/uauc/editObserverSettingData`,
  },
  predictiveAnalysis: `${mainUrl}/summary/birdeyeview`,
  formType1: {
    createForm: `${mainUrl}/formtype1/createform`,
    editForm: `${mainUrl}/formtype1/editform`,
    formNumber: `${mainUrl}/formtype1/formcount`,
    deleteForm: `${mainUrl}/formtype1/deleteForm`,
    unPublishedlist: `${mainUrl}/formtype1/unpublishedlist`,
    publishedlist: `${mainUrl}/formtype1/publishedlist`,
    makeUnpublishedForm: `${mainUrl}/formtype1/makeUnpublishedForm`,
    assignLocation: `${mainUrl}/formtype1/assignlocation`,
    createformdetails: `${mainUrl}/formtype1/createformdetails`,
    userFormListing: `${mainUrl}/formtype1/form`,
    userCompletedFormListing: `${mainUrl}/formtype1/completedform`,
    userFormDetails: `${mainUrl}/formtype1/userformdetails`,
    sectionList: `${mainUrl}/formtype1/sectionList`,
    archiveList: `${mainUrl}/formtype1/archivelist`,
    makeUnarchieveForm: `${mainUrl}/formtype1/makeUnarchieveForm`,
    marketPlace: `${mainUrl}/formtype1/marketplace`,
    useMarketPlace: `${mainUrl}/formtype1/usemarketplace`,
    useDocumentFromMarketPlace: `${mainUrl}/formtype1/usedocumentfrommarketplace`,
    settingPage: `${mainUrl}/formtype1/settingpage`,
    setting: `${mainUrl}/formtype1/setting`,
    escalationList: `${mainUrl}/formtype1/escalationlist`,
    moduleDashboard: `${mainUrl}/formtype1/moduledashboard`,
    unlockRequestList: `${mainUrl}/formtype1/unlockrequestlist`,
    personalUnlockRequestList: `${mainUrl}/formtype1/personalunlockrequest`,
    unlockForm: `${mainUrl}/formtype1/unlockform`,
    unlockRequestUser: `${mainUrl}/formtype1/unlockrequestuser`,
    userResponse: `${mainUrl}/formtype1/userresponse`,
    assignUser: `${mainUrl}/formtype1/assignuser`,
    assignUserList: `${mainUrl}/formtype1/assignuserlist`,
    unassignUser: `${mainUrl}/formtype1/unassignuser`,
    selectedFormDetailUserSide: `${mainUrl}/formtype1/selectedfromdetailuserside`,
    selectedFormDetailStat: `${mainUrl}/formtype1/selectedfromdetailstat`,
    selectedFormDetailAnalysis: `${mainUrl}/formtype1/selectedfromdetailanalysis`,
    escalationAddLevel: `${mainUrl}/formtype1/escalationaddlevel`,
    escalationEditLevel: `${mainUrl}/formtype1/escalationeditlevel`,
    escalationDeleteLevel: `${mainUrl}/formtype1/escalationdeletelevel`,
    escalationDeleteUser: `${mainUrl}/formtype1/escalationdeleteuser`,
    escalationAddUser: `${mainUrl}/formtype1/escalationadduser`,
    selectedFormDetailUserSideFilter: `${mainUrl}/formtype1/selectedfromdetailusersidefilter`,
    checkDuplicateSectionName: `${mainUrl}/formtype1/sectionNameCheck`,
    locationList: `${mainUrl}/formtype1/locationlist`,
    locationListNew: `${springUrl}/formtype1/locationlist`,
    formAssignUserList: `${mainUrl}/formtype1/formassignuserlist`,
    formAssignUser: `${mainUrl}/formtype1/formassignuser`,
    deleteFormAssignUser: `${mainUrl}/formtype1/deleteformassignuser`,
    todaysForm: `${mainUrl}/formtype1/todaysform`,
    titleValidate: `${mainUrl}/formtype1/titlevalidation`,
    categoryValidate: `${mainUrl}/formtype1/categoryvalidation`,
    publishedTemplateList: `${mainUrl}/formtype1/publishedtemplatelist`,
    allSchedule: `${mainUrl}/formtype1/alluserschedulelist`,
    workPermit: `${mainUrl}/formtype1/workpermit`,
    workPermitUse: `${mainUrl}/formtype1/workpermituse`,
    //workPermitList: `${springUrl}/workpermit/scheduleList`,
    workPermitList: `${mainUrl}/formtype1/workpermitlist`,
    workPermitListByDepartmentLocation: `${mainUrl}/formtype1/workPermitListByDepartmentLocation`,
    workPermitListByDepartmentLocationNew: `${springUrl}/workpermit/listbydeptlocation`,
    workPermitApprove: `${mainUrl}/formtype1/workpermitapprove`,
    workPermitClose: `${mainUrl}/formtype1/workpermitclose`,
    workPermitDecline: `${mainUrl}/formtype1/workpermitdecline`,
    workPermitExtend: `${mainUrl}/formtype1/workpermitextend`,
    workPermitUseDelete: `${mainUrl}/formtype1/workpermitusedelete`,
    workPermitEdit: `${mainUrl}/formtype1/workpermitedit`,
    workPermitAssignEdit: `${mainUrl}/formtype1/assignedworkpermitedit`,
    archivedWorkPermitList: `${mainUrl}/formtype1/archivedworkpermitlist`,
    changeFrequencyType: `${mainUrl}/formtype1/changefrequencytype`,
    surveyUse: `${mainUrl}/formtype1/surveyuse`,
    surveyList: `${mainUrl}/formtype1/surveylist`,
    changeDuration: `${mainUrl}/formtype1/changeduration`,
    monthwisecount: `${mainUrl}/formtype1/monthwisecount`,
    extendedWorkPermitList: `${mainUrl}/formtype1/extendedworkpermitlist`,
    useAsTemplate: `${mainUrl}/formtype1/useastemplate`,
    publishedListFilter: `${mainUrl}/formtype1/publishedlistfilter`,
    unPublishedListFilter: `${mainUrl}/formtype1/unpublishedlistfilter`,
    marketPlaceFilter: `${mainUrl}/formtype1/marketplacefilter`,
    scheduleNotification: `${mainUrl}/formtype1/schedulenotification`,
    formStatusChange: `${mainUrl}/formtype1/formstatuschange`,
    addQuestion: `${mainUrl}/formtype1/addquestion`,
    addSection: `${mainUrl}/formtype1/addsection`,
    createBasicForm: `${mainUrl}/formtype1/createbasicform`,
    editBasicForm: `${mainUrl}/formtype1/editbasicform`,
    deleteQuestion: `${mainUrl}/formtype1/deletequestion`,
    deleteSection: `${mainUrl}/formtype1/deletesection`,
    surveyDelete: `${mainUrl}/formtype1/surveydelete`,
    archivedSurveyList: `${mainUrl}/formtype1/archivedsurveylist`,
    surveyListTotalResponse: `${mainUrl}/formtype1/surveylisttotalresponse`,
    assignElearningUsers: `${mainUrl}/formtype1/assignelearningusers`,
    elearningAssignUsers: `${mainUrl}/formtype1/elearningassignuserlist`,
    deleteElearnAssignUser: `${mainUrl}/formtype1/deleteelearnassignuser`,
    elearningList: `${mainUrl}/formtype1/elearninglist`,
    eLearningAssignUserInfo: `${mainUrl}/formtype1/euserinfo`,
    addElearningStartDate: `${mainUrl}/formtype1/addelearningstartdate`,
    getChangeInprogressStatus: `${mainUrl}/formtype1/getchangeinprogressstatus`,
    categoryWiseFilter: `${mainUrl}/formtype1/categorywisefilter`,
    categoryWiseFilterCount: `${mainUrl}/formtype1/categorywisefiltercount`,
    allTabCategorywiseFilter: `${mainUrl}/formtype1/alltabcategorywisefilter`,
    categoryWiseSurveyFilter: `${mainUrl}/formtype1/categorywisesurveyfilter`,
    getElearningData: `${mainUrl}/formtype1/getelearningdata`,
    elearnStatusChange: `${mainUrl}/formtype1/elearnstatuschange`,
    updateLastTime: `${mainUrl}/formtype1/updatelasttime`,
    getLastAccessTime: `${mainUrl}/formtype1/getlastaccesstime`,
    getElearnScore: `${mainUrl}/formtype1/getelearnscore`,
    getDataCollectionDetail: `${mainUrl}/formtype1/getdatacollectionbyid`,
    getSurveyData: `${mainUrl}/formtype1/getsurveydata`,
    workPermitListClosed: `${mainUrl}/formtype1/workpermitlistclosed`,
    checkContractorRight: `${mainUrl}/formtype1/checkcontractorright`,
    assAssignUserList: `${mainUrl}/formtype1/assfbackassignuserlist`,
    addAssFbackRights: `${mainUrl}/formtype1/addassfbackrights`,
    deleteAssFbackRights: `${mainUrl}/formtype1/deleteassfbackrights`,
    assessmentFbackRights: `${mainUrl}/formtype1/assessmentfbackrights`,
    workPermitListScheduleCount: `${mainUrl}/formtype1/workpermitlistschedulecount`,
    archivedWorkpPrmitCount: `${mainUrl}/formtype1/archivedworkpermitcount`,
    createbasicformfromexcel: `${mainUrl}/formtype1/createbasicformfromexcel`,
  },
  formStat: {
    moduleDashboard: `${mainUrl}/formstat/moduledashboard`,
    moduleDashboardFilter: `${mainUrl}/formstat/moduledashboardfilter`,
    safetyHeadDashboardProjectFormFilter: `${mainUrl}/formtype1/formproject`,
    formTypeDashboard: `${mainUrl}/formstat/formtypedashboard`,
  },
  nmModule: {
    nmDetail: `${mainUrl}/listnm/nearmissdetail`,
    springnmDetail: `${springUrl}/nm/nearmissdetail`,
    nmdashboard: `${mainUrl}/listnm/nmwebdashboardprojectwise`,

    nmTracker: `${mainUrl}/listnm/trackerlist`,
    springNmTracker: `${springUrl}/nm/trackerlist`,
    nmHeaderCount: `${springUrl}/nm/headercounts`,
    nmList: `${springUrl}/nm/kanbanview`,
    nmEdit: `${mainUrl}/listnm/nmedit`,
    springnmEdit: `${springUrl}/nm/reportedit`,
    nmProgressList: `${mainUrl}/listnm/inprogresslist`,
    nmPendingList: `${mainUrl}/listnm/pendinglist`,
    nmCompletedList: `${mainUrl}/listnm/completedlist`,
    nmworkflowformsetting: `${mainUrl}/listnm/nmworkflowformsetting`,
    springnmworkflowformsetting: `${stageUrl}/nm/editSettingData`,
    nmsavedformsetting: `${mainUrl}/nm/nmsavedformsetting`,
    springnmsavedformsetting: `${stageUrl}/nm/settingData`,
    springirasavedformsetting: `${stageUrl}/ira/settingData`,
    iraTeammemberlist: `${springUrl}/ira/listteamMember`,
    trackerfilter: `${mainUrl}/listnm/trackerfilter`,
    pendingfilter: `${springUrl}/nm/pendingfilter`,
    inprogressfilter: `${springUrl}/nm/inprogressfilter`,
    completedfilter: `${springUrl}/nm/completefilter`,
    nmlistexport: `${mainUrl}/listnm/nmlistexportoverall`,
    nmExport: `${springUrl}/nm/excelDownload`,
    nmtrackerlistexport: `${mainUrl}/listnm/nmtrackerexportoverall`,
    serviceandseverityfilter: `${mainUrl}/listnm/serviceandseverityfilter`,
    projectandseverityfilter: `${mainUrl}/listnm/projectandseverityfilter`,
    monthwisereportfilter: `${mainUrl}/listnm/monthwisereportfilter`,
    deleteNMReport: `${mainUrl}/listnm/deletereportednm`,
    springDeleteNMReport: `${springUrl}/nm/delete`,
    commentList: `${mainUrl}/listnm/nmcommentlist`,
    nmDaysCount: `${mainUrl}/listnm/nmdayscount`,
    nmDaysCountV1: `${springUrl}/nm/nmDaysCount`,
    deleteIncidentPerson: `${mainUrl}/listnm/deletenmincidentperson`,
    nmCalenderSort: `${mainUrl}/listnm/nmcalendersort`,
  },
  iraModule: {
    iraDetails: `${springUrl}/ira/iradetail`,
    // iraDetails: `${mainUrl}/listira/iradetails`,
    iraTextAnalysi: `${springUrl}/ira/observationanalysis`,
    iraEdit: `${springUrl}/ira/reportedit`,
    // iraEdit: `${mainUrl}/listira/iraedit`,
    workingShiftMasterList: `${springUrl}/ira/iraworkingshift`,
    workingTypeMasterList: `${springUrl}/ira/listworktype`,
    iraDashboard: `${springUrl}/ira/webdashboardprojectwise`,
    iraheaderCounts: `${springUrl}/ira/iraheadercounts`,
    iratrackerlist: `${springUrl}/ira/trackerlist`,
    irakanbanview: `${springUrl}/ira/kanbanview`,
    iraPending: `${mainUrl}/listira/pendinglist`,
    iraInprogress: `${mainUrl}/listira/inprogresslist`,
    iraCompleted: `${mainUrl}/listira/completedlist`,
    deleteIRAReport: `${springUrl}/ira/delete`,
    iraworkflowformsetting: `${springUrl}/ira/iraworkflowformsetting`,
    irasavedformsetting: `${springUrl}/ira/irasavedformsetting`,
    springiraworkflowformsetting: `${stageUrl}/ira/settingData`,
    trackerfilterira: `${springUrl}/ira/trackerlist`,
    iraTeammemberlist: `${springUrl}/ira/listteamMember`,
    //iralistfilter: `${springUrl}/ira/iralistfilter`,
    iralistfilter: `${springUrl}/ira/kanbanview`,
    iralistexport: `${springUrl}/ira/excelDownload`,
    iratrackerlistexport: `${mainUrl}/listira/iratrackerexportoverall`,
    serviceandincidenttypefilter: `${mainUrl}/listira/serviceandincidenttypefilter`,
    projectandincidenttypefilter: `${mainUrl}/listira/projectandincidenttypefilter`,
    activityandincidenttypefilter: `${mainUrl}/listira/activityandincidenttypefilter`,
    incidenttimeandincidenttypefilter: `${mainUrl}/listira/incidenttimeandincidenttypefilter`,
    deleteIncidentPerson: `${springUrl}/ira/deleteincidentperson`,
    iraDaysCount: `${springUrl}/ira/iradayscount`,
    iraExportExcel: `${springUrl}/ira/excelDownload`,
    iraCapaExportExcel: `${springUrl}/ira/capaExcelDownload`,
  },
  companyList: `${stageUrl}/company/list`,
  companyCreate: `${stageUrl}/company/create`,
  companyDetail: `${stageUrl}/company/detail`,
  companyUpdate: `${stageUrl}/company/update`,
  companyDelete: `${stageUrl}/company/delete`,
  companyRestore: `${stageUrl}/company/restore`,
  streamsForAddition: `${stageUrl}/company/streamsForAddition`,
  addStream: `${stageUrl}/company/addStream`,
  serviceListOld: `${mainUrl}/service/servicelist`,
  serviceList: `${springUrl}/service/servicelist`,
  projectList: `${mainUrl}/service/projectlist`,
  subVerticalList: `${stageUrl}/projectcategory/list`,
  userServiceProject: `${mainUrl}/service/userserviceproject`,
  userDeleteAlternateUserList: `${mainUrl}/service/userdeleteinfo`,
  projectListForm: `${springUrl}/service/projectlistform`,
  projectListFormOld: `${mainUrl}/service/projectlistform`,
  zoneContractorFlag: `${mainUrl}/service/checkavailaibilty`,
  activitylist: `${springUrl}/master/activitylist`,
  activitylistOld: `${mainUrl}/master/activitylist`,
  externalactivitylist: `${mainUrl}/master/externalactivitylist`,
  formCategoryList: `${mainUrl}/master/formcategorylist`,
  //formCategoryList: `${mainUrl}/master/formcategorylistadmin`,
  departmentList: `${springUrl}/department/list`,
  departmentListOld: `${mainUrl}/master/departmentlist`,
  externalDepartmentList: `${mainUrl}/master/externaldepartmentlist`,
  contractorList: `${mainUrl}/master/contractorlist`,
  contractorListNew: `${springUrl}/master/contractorlist`,
  divisionList: `${springUrl}/division/list`,
  externalContractorList: `${mainUrl}/master/externalcontractorlist`,
  zoneList: `${springUrl}/master/zonelist`,
  zoneListOld: `${mainUrl}/master/zonelist`,
  externalZoneList: `${mainUrl}/master/externalzonelist`,
  hazardList: `${springUrl}/master/hazardlist`,
  hazardListOld: `${mainUrl}/master/hazardlist`,
  externalHazardList: `${mainUrl}/master/externalhazardlist`,
  subhazardList: `${springUrl}/master/subhazardlist`,
  subhazardListOld: `${mainUrl}/master/subhazardlist`,
  externalSubhazardList: `${mainUrl}/master/externalsubhazardlist`,
  barrierList: `${springUrl}/master/barrierlist`,
  barrierListOld: `${mainUrl}/master/barrierlist`,
  externalbarrierList: `${mainUrl}/master/externalbarrierlist`,
  locationList: `${springUrl}/master/locationlist`,
  locationListOld: `${mainUrl}/master/locationlist`,
  externalLocationList: `${mainUrl}/master/externallocationlist`,
  closingRightUserList: `${springUrl}/master/closingrightuserlist`,
  externalClosingRightUserList: `${mainUrl}/master/externalclosingrightuserlist`,
  closingRightUserListPsh: `${mainUrl}/master/closingrightuserlistpsh`,
  UserList: `${mainUrl}/master/userlist`,
  controlMeasureList: `${mainUrl}/master/controlmeasurelist`,
  controlMeasureListSpring: `${springUrl}/master/controlmeasurelist`,
  externalControlMeasureList: `${mainUrl}/master/externalcontrolmeasurelist`,
  sourceList: `${springUrl}/master/sourcelist`,
  sourceListOld: `${mainUrl}/master/sourcelist`,
  externalSourceList: `${mainUrl}/master/externalsourcelist`,
  reportSetting: {
    formParameter: `${mainUrl}/reortSetting/formParameter`,
    externalFormParameter: `${mainUrl}/reortSetting/externalformParameter`,
    checkStorage: `${mainUrl}/reortSetting/checkStorage`,
  },
  createReport: {
    soiReport: `${mainUrl}/listSoi/soireport`,
    uaucReport: `${springUrl}/uauc/report`,
    nmReport: `${mainUrl}/listnm/nmreport`,
    springnmReport: `${springUrl}/nm/report`,
    // iraReport: `${mainUrl}/listira/report`,
    iraReport: `${springUrl}/ira/report`,
    springIraReport: `${springUrl}/ira/report`,
    externalSoiReport: `${mainUrl}/listSoi/externalsoireport`,
    uaucExternalSoiReport: `${springUrl}/uauc/externalReport`,
    externalNmReport: `${mainUrl}/listnm/externalnmreport`,
    springexternalNmReport: `${springUrl}/nm/externalreport`,
    externalIraReport: `${springUrl}/ira/externalreport`,
  },
  adminUser: {
    allUserNumber: `${stageUrl}/adminuser/allusernumber`,
    alluserList: `${mainUrl}/adminuser/alluserlist`,
    safetyheadList: `${mainUrl}/adminuser/safetyhead`,
    addSafetyHead: `${mainUrl}/adminuser/safetyheadd`,
    deleteSafetyHead: `${mainUrl}/adminuser/safetyheaddelete`,
    userStatusChange: `${mainUrl}/adminuser/userchangestatus`,
    userCSVUpload: `${mainUrl}/adminuser/usermasteraddcsv`,
    activeUserUpload: `${stageUrl}/userMaster/uploadCsv`,
    projectHeadList: `${mainUrl}/adminuser/phuser`,
    addProjectHead: `${mainUrl}/adminuser/phadd`,
    deleteProjectHead: `${mainUrl}/adminuser/phdelete`,
    corporateUserList: `${mainUrl}/adminuser/corporateuser`,
    addCorporateUser: `${mainUrl}/adminuser/cuadd`,
    deleteCorporateUser: `${mainUrl}/adminuser/cudelete`,
    observerList: `${mainUrl}/adminuser/obuser`,
    observerDelete: `${mainUrl}/adminuser/obdelete`,
    observerAdd: `${mainUrl}/adminuser/obadd`,
    reportingUserList: `${mainUrl}/adminuser/ruuser`,
    reportingUserDelete: `${mainUrl}/adminuser/rudelete`,
    reportingUserAdd: `${mainUrl}/adminuser/ruadd`,
    plantSafHeadList: `${mainUrl}/adminuser/pshuser`,
    plantSafetyHeadAdd: `${mainUrl}/adminuser/pshadd`,
    plantSafetyHeadDelete: `${mainUrl}/adminuser/pshdelete`,
    contractorList: `${mainUrl}/admincon/list`,
    departmentList: `${mainUrl}/admindept/list`,
    changeUserField: `${mainUrl}/adminuser/changeuserfield`,
    adminUserList: `${stageUrl}/adminuser/list`,
  },
  adminDepartment: {
    adminDepartmentList: `${mainUrl}/admindept/list`,
    getDepartmentList: `${stageUrl}/divDep/getDepartmentList`,
    searchDeparmentList: `${mainUrl}/adminservice/projectdeptlistsearch`,
    addDepartment: `${mainUrl}/admindept/add`,
    editDepartment: `${mainUrl}/admindept/editname`,
    activateDepartment: `${mainUrl}/admindept/activate`,
    deleteDepartment: `${mainUrl}/admindept/delete`,
    headList: `${mainUrl}/admindept/userlist`,
    csvUpload: `${mainUrl}/admindept/deptmasteraddcsv`,

    removeHead: `${mainUrl}/admindept/removehead`,
  },
  adminContractor: {
    contractorList: `${mainUrl}/admincon/list`,
    addContractor: `${mainUrl}/admincon/add`,
    editContractor: `${mainUrl}/admincon/editname`,
    deleteContractor: `${mainUrl}/admincon/delete`,
    activateContractor: `${mainUrl}/admincon/activate`,
    headList: `${mainUrl}/admincon/userlist`,
    csvUpload: `${mainUrl}/admincon/conmasteraddcsv`,
    removeHead: `${mainUrl}/admincon/removehead`,
  },
  adminModule: {
    moduleList: `${mainUrl}/adminmodule/modulelist`,
    bulkProjectService: `${stageUrl}/service/bulkProjectService`,
    projectModuleList: `${stageUrl}/service/projectmodulelist`,
  },
  aiModel: {
    aiModelList: `${mainUrl}/adminaimodel/aimodelList`,
  },
  adminHira: {
    allNumber: `${mainUrl}/adminhirastat/num`,
    activity: {
      activityList: `${mainUrl}/adminhiraact/list`,
      activityAdd: `${mainUrl}/adminhiraact/add`,
      activityEdit: `${mainUrl}/adminhiraact/edit`,
      activityDelete: `${mainUrl}/adminhiraact/delete`,
      activityActivate: `${mainUrl}/adminhiraact/activate`,
      activityImportList: `${superadminAPI}/export/activitylist`,
      addBulkActivity: `${mainUrl}/adminhiraact/exportlistadd`,
      csvUpload: `${mainUrl}/adminhiraact/addcsv`,
      safetyStandardList: `${superadminAPI}/safetystd/safetystdmasterlist`,
      safetySubStandardList: `${superadminAPI}/safetystd/subsafetystdmasterlist`,
      industryList: `${superadminAPI}/superadmin/industryList`,
      hazardDelete: `${mainUrl}/adminhiraact/deletehazardid`,
      controlMeasureDelete: `${mainUrl}/adminhiraact/deletecontrolmeasure`,
    },

    hazard: {
      hazardList: `${mainUrl}/adminhirahaz/list`,
      hazardAdd: `${mainUrl}/adminhirahaz/add`,
      hazardEdit: `${mainUrl}/adminhirahaz/edit`,
      hazardDelete: `${mainUrl}/adminhirahaz/delete`,
      hazardActivate: `${mainUrl}/adminhirahaz/activate`,
      csvUpload: `${mainUrl}/adminhirahaz/addcsv`,
      exportList: `${superadminAPI}/export/hazardlist`,
      addExportList: `${mainUrl}/adminhirahaz/hazardexportlistadd`,
    },
    subHazard: {
      subHazardList: `${mainUrl}/adminhirasubhaz/list`,
      subHazardAdd: `${mainUrl}/adminhirasubhaz/add`,
      subHazardEdit: `${mainUrl}/adminhirasubhaz/edit`,
      subHazardDelete: `${mainUrl}/adminhirasubhaz/delete`,
    },
    barrier: {
      barrierList: `${mainUrl}/adminhirabar/list`,
      barrierAdd: `${mainUrl}/adminhirabar/add`,
      barrierEdit: `${mainUrl}/adminhirabar/edit`,
      barrierDelete: `${mainUrl}/adminhirabar/delete`,
      barrierActivate: `${mainUrl}/adminhirabar/activate`,
      csvUpload: `${mainUrl}/adminhirabar/addcsv`,
      exportList: `${superadminAPI}/export/barrierlist`,
      addExportList: `${mainUrl}/adminhirabar/barrierexportlistadd`,
    },
    controlMeasure: {
      cmList: `${stageUrl}/controlMeasure/list`,
      addCm: `${stageUrl}/controlMeasure/create`,
      updateCm: `${stageUrl}/controlMeasure/update`,
      deleteCm: `${stageUrl}/controlMeasure/delete`,
      uploadCm: `${stageUrl}/controlMeasure/importExcelCsv`,
      exportCm: `${stageUrl}/controlMeasure/exportExcelCsv`,
      cmActivity: `${stageUrl}/controlMeasure/activity_list`,
      addCMActivity: `${stageUrl}/controlMeasure/addToActivity`,
      removeCMActivity: `${stageUrl}/controlMeasure/removeFromActivity`,
      restoreCm: `${stageUrl}/controlMeasure/retrieve`,
    },
  },

  adminLMS: {
    master: {
      categoryList: `${stageUrl}/categoryMaster/list`,
      categoryCreate: `${stageUrl}/categoryMaster/create`,
      categoryUpdate: `${stageUrl}/categoryMaster/update`,
      categoryDelete: `${stageUrl}/categoryMaster/delete`,

      importExcelCsv: `${stageUrl}/common/importExcelCsv`,

      courseList: `${stageUrl}/courseMaster/list`,
      courseCreate: `${stageUrl}/courseMaster/create`,
      courseUpdate: `${stageUrl}/courseMaster/update`,
      courseDelete: `${stageUrl}/courseMaster/delete`,

      languageList: `${stageUrl}/languageMaster/list`,
      languageCreate: `${stageUrl}/languageMaster/create`,
      languageUpdate: `${stageUrl}/languageMaster/update`,
      languageDelete: `${stageUrl}/languageMaster/delete`,

      tagList: `${stageUrl}/tagMaster/list`,
      tagCreate: `${stageUrl}/tagMaster/create`,
      tagUpdate: `${stageUrl}/tagMaster/update`,
      tagDelete: `${stageUrl}/tagMaster/delete`,

      criteriaList: `${stageUrl}/criteriaMaster/list`,
      criteriaCreate: `${stageUrl}/criteriaMaster/create`,
      criteriaUpdate: `${stageUrl}/criteriaMaster/update`,
      criteriaDelete: `${stageUrl}/criteriaMaster/delete`,

      criteriaDetail: `${stageUrl}/criteriaMaster/detail`,
      criteriaAddData: `${stageUrl}/criteriaMaster/addData`,
      criteriaUpdateData: `${stageUrl}/criteriaMaster/updateData`,
      criteriaDeleteData: `${stageUrl}/criteriaMaster/deleteData`,

      defaultCertificate: `${stageUrl}/certificateMaster/fetchSetting`,
      setDefaultCertificate: `${stageUrl}/certificateMaster/editSetting`,
    },
  },

  userLms: {
    lmsCreateForm: `${springUrl}/course/create`,
    lmsContentCreationForm: `${springUrl}/course/lesson/addSectionContent`,
    contentDocumentUpload: `${springUrl}/course/lesson/addDocumentsForContent`,
    formCategoryListAdmin: `${mainUrl}/master/formcategorylistadmin`,
    addcategory: `${mainUrl}/master/addformcategory`,
    editcategory: `${mainUrl}/master/editformcategory`,
    deletecategory: `${mainUrl}/master/deleteformcategory`,
    activateCategory: `${mainUrl}/master/activate`,
    deleteCourse: `${springUrl}/course/deleteCourse`,
    learningActivity: `${springUrl}/course/dashboard/learningActivity`,
    myCourses: `${springUrl}/course/dashboard/myCourses`,
    myProgress: `${springUrl}/course/dashboard/myProgress`,
    learnerDashboard: `${springUrl}/course/dashboard/learnerDashboard`,
    courseStats: `${springUrl}/course/stats`,
    recentCourse: `${springUrl}/course/courses/recent`,
    getContentById: `${springUrl}/course/content/details`,
    deleteExternalLink: `${springUrl}/course/content/externalLink/delete`,
    updateExternalLink: `${springUrl}/course/content/externalLink/update`,
    updatequiz: `${springUrl}/course/quiz/update`,
    deleteQuestion: `${springUrl}/course/content/quizOrQuestion/delete`,
    saveContentResources: `${springUrl}/course/lesson/addResourceForContent`,
    startCourse: `${springUrl}/course/progress/manage`,
    getCertificate: `${springUrl}/course/certificate/issue`,
    selfEnrollCourse: `${springUrl}/course/selfEnroll`,
    //save user last watching videos logs
    setLastUserWatchingContent: `${springUrl}/course/setLastWatchingContent`,
    getLastUserWatchingLogs: `${springUrl}/course/getLastWatchingContent`,
    exportAllCourseData: `${springUrl}/course/exportAllCoursesReport`,
    exportCourseLearnerReport: `${springUrl}/course/exportCourseLearnerReport`,
  },

  Deptmaster: {
    divList: `${stageUrl}/divDep/getDivisionList`,
    deptList: `${stageUrl}/divDep/getDepartmentList`,
    deleteDiv: `${stageUrl}/divDep/deleteDivision`,
    restoreDiv: `${stageUrl}/divDep/restoreDivision`,
    restoreDept: `${stageUrl}/divDep/restoreDepartment`,
    addDiv: `${stageUrl}/divDep/addDivision`,
    addDept: `${stageUrl}/divDep/addDepartment`,
    deleteDept: `${stageUrl}/divDep/deleteDepartment`,
    updateDiv: `${stageUrl}/divDep/updateDivision`,
  },

  DivDeptproject: {
    divProjList: `${stageUrl}/divDep/getDivisionListForProject`,
    divProjAddList: `${stageUrl}/divDep/getDivisionListForAddition`,
    divProjAdd: `${stageUrl}/divDep/addDivisionForProject`,
    divProjDelete: `${stageUrl}/divDep/deleteDivisionForProject`,
    departmentListByDivision: `${stageUrl}/divDep/getDepartmentListForProject`,
    deptProjAddList: `${stageUrl}/divDep/getDepartmentListForAddition`,
    deptProjAdd: `${stageUrl}/divDep/addDepartmentForProject`,
  },

  adminCategory: {
    categoryList: `${mainUrl}/master/formcategorylist`,
    formCategoryListAdmin: `${mainUrl}/master/formcategorylistadmin`,
    addcategory: `${mainUrl}/master/addformcategory`,
    editcategory: `${mainUrl}/master/editformcategory`,
    deletecategory: `${mainUrl}/master/deleteformcategory`,
    activateCategory: `${mainUrl}/master/activate`,
    restoreDocumentCategory: `${stageUrl}/documentMaster/restoreDocumentCategory`,
  },

  adminDesignation: {
    designationList: `${mainUrl}/admindesign/list`,
    searchdesignationList: `${mainUrl}/admindesign/searchdesignation`,
    designationAdd: `${mainUrl}/admindesign/add`,
    designationeEdit: `${mainUrl}/admindesign/edit`,
    designationDelete: `${mainUrl}/admindesign/delete`,
    csvupload: `${mainUrl}/admindesign/designmasteraddcsv`,
    designationRestore: `${mainUrl}/admindesign/reactivedesignation`,
  },
  adminSource: {
    sourceList: `${mainUrl}/adminsourcemaster/list`,
    springSourceList: `${stageUrl}/source/list`,
    sourceAdd: `${mainUrl}/adminsourcemaster/add`,
    springSourceAdd: `${stageUrl}/source/create`,
    sourceEdit: `${stageUrl}/source/update`,
    sourceDelete: `${mainUrl}/adminsourcemaster/delete`,
    springSourceDelete: `${stageUrl}/source/delete`,
    sourceRestore: `${mainUrl}/adminsourcemaster/reactivesource`,
    springSourceRestore: `${stageUrl}/source/retrieve`,
    springImportExcelCsv: `${stageUrl}/source/importExcelCsv`,
    springExportExcelCsv: `${stageUrl}/source/exportExcelCsv`,
  },

  adminServices: {
    serviceProjectList: `${mainUrl}/adminservice/serviceprojectdropdownlist`,
    serviceList: `${mainUrl}/adminservice/list`,
    designationList: `${stageUrl}/designation/list`,
    activeUserExcelDownload: `${stageUrl}/service/exportExcelCsvActuser`,
    springserviceList: `${stageUrl}/service/list`,
    projectList: `${mainUrl}/adminservice/projectlist`,
    springprojectList: `${stageUrl}/service/ppclist`,
    springPlantList: `${stageUrl}/service/unassignedppclist`,
    projectClose: `${mainUrl}/adminservice/adminprojectclose`,
    projectOpen: `${mainUrl}/adminservice/adminprojectopen`,
    addService: `${mainUrl}/adminservice/addservice`,
    editService: `${mainUrl}/adminservice/editservice`,
    // deleteService: `${mainUrl}/adminservice/deleteservice`, // COMMENTED OUT - Old soft delete API
    deleteService: `${stageUrl}/service/delete`, // New delete API endpoint
    // restoreService: `${mainUrl}/adminservice/restoreservice`, // COMMENTED OUT - Old soft restore API
    restoreService: `${stageUrl}/service/restore`, // New restore API endpoint
    activateService: `${mainUrl}/adminservice/activeservice`,
    removeServiceHead: `${mainUrl}/adminservice/removeservicehead`,
    bscReport: {
      leadingLagging: {
        list: `${mainUrl}/weightage/formleadlagList`,
        targetInputList: `${mainUrl}/weightage/fetchtargetinputlist`,
        update: `${mainUrl}/weightage/updateleadlagtarget`,
      },
      weightage: {
        list: `${mainUrl}/weightage/formweightageList`,
        save: `${mainUrl}/weightage/updateweightage`,
      },
    },
    projects: {
      stateList: `${mainUrl}/adminservice/projectstatelist`,
      cityList: `${mainUrl}/adminservice/projectcitylist`,
      addProject: `${mainUrl}/adminservice/addproject`,
      springaddProject: `${stageUrl}/service/assignppc`,
      editProject: `${mainUrl}/adminservice/projectdetailedit`,
      springeditProject: `${stageUrl}/service/editppcdetail`,
      // deleteProject: `${mainUrl}/adminservice/deleteproject`, // COMMENTED OUT - Old soft delete API
      deleteProject: `${stageUrl}/project/delete`, // New delete API endpoint
      // restoreProject: `${mainUrl}/adminservice/restoreproject`, // COMMENTED OUT - Old soft restore API
      restoreProject: `${stageUrl}/project/restore`, // New restore API endpoint
      activateProject: `${mainUrl}/adminservice/activeproject`,
      editProjectHead: `${mainUrl}/adminservice/projectheadedit`,
      projectDetail: `${mainUrl}/adminservice/projectdetail`,
      springprojectDetail: `${stageUrl}/service/ppcdetail`,
      projectAIModel: `${mainUrl}/adminservice/projectaimodellist`,
      zoneList: `${mainUrl}/adminservice/projectzonelist`,
      zoneListNew: `${stageUrl}/zoneLocation/listZone`,
      zoneCsv: `${mainUrl}/adminservice/projectzonecsvupload`,
      zoneLocationCsv: `${mainUrl}/adminservice/projectlocationcsvupload`,
      addCamera: `${mainUrl}/adminservice/addcamera`,
      editCamera: `${mainUrl}/adminservice/editcamera`,
      deleteCamera: `${mainUrl}/adminservice/deletecamera`,
      getAllCamera: `${mainUrl}/adminservice/getallcamera`,
      addZone: `${mainUrl}/adminservice/projectaddzone`,
      addZoneNew: `${stageUrl}/zoneLocation/addZone`,

      editZone: `${mainUrl}/adminservice/projecteditzone`,
      editZoneNew: `${stageUrl}/zoneLocation/updateZone`,

      deleteZone: `${mainUrl}/adminservice/projectdeletezone`,
      deleteZoneNew: `${stageUrl}/zoneLocation/deleteZone`,
      restoreZoneNew: `${stageUrl}/zoneLocation/restoreZone`,

      activateZone: `${mainUrl}/adminservice/projectactivezone`,
      removeZoneHead: `${mainUrl}/adminservice/removeprojectzonehead`,
      locationList: `${mainUrl}/adminservice/projectlocationlist`,
      locationListNew: `${stageUrl}/zoneLocation/listLocation`,

      searchLocationList: `${mainUrl}/adminservice/projectlocationlistsearch`,
      addLocation: `${mainUrl}/adminservice/projectaddlocation`,
      addLocationNew: `${stageUrl}/zoneLocation/addLocation`,
      editLocation: `${mainUrl}/adminservice/projecteditlocation`,
      editLocationNew: `${stageUrl}/zoneLocation/updateLocation`,
      deleteLocation: `${mainUrl}/adminservice/projectdeletelocation`,
      deleteLocationNew: `${stageUrl}/zoneLocation/deleteLocation`,
      activateLocation: `${mainUrl}/adminservice/projectactivelocation`,
      activateLocationNew: `${stageUrl}/zoneLocation/restoreLocation`,

      removeLocationHead: `${mainUrl}/adminservice/removeprojectzonelocationhead`,
      departmentList: `${mainUrl}/adminservice/projectdeptlist`,
      searchdepartmentList: `${mainUrl}/adminservice/projectdeptlistsearch`,
      contractorList: `${mainUrl}/adminservice/projectconlist`,
      contractorListSpring: `${stageUrl}/contractor/for-addition`,

      addDepartment: `${mainUrl}/adminservice/projectadddept`,
      editDepartment: `${mainUrl}/adminservice/projecteditdept`,
      deleteDepartment: `${mainUrl}/adminservice/projectdeletedept`,
      removeDepartmentHead: `${mainUrl}/adminservice/removeprojectdepthead`,
      addContractor: `${mainUrl}/adminservice/projectaddcon`,
      addContractorSpring: `${stageUrl}/contractor/add-to-project`,
      editContractor: `${mainUrl}/adminservice/projecteditcon`,
      deleteContractor: `${mainUrl}/adminservice/projectdeletecon`,
      deleteContractorSpring: `${stageUrl}/contractor/deleteFromProject`,
      removeContractorHead: `${mainUrl}/adminservice/removeprojectconhead`,
      addDepartmentList: `${mainUrl}/adminservice/projectdeptlisforaddition`,
      addContractorList: `${mainUrl}/adminservice/projectconlistforadition`,
      addContractorListSpring: `${stageUrl}/contractor/listByProject`,
      userHeadList: `${mainUrl}/adminservice/userlistforaddition`,
      userBulkHeadList: `${mainUrl}/adminservice/fetchuserforbulkassign`,
      projectSpace: `${mainUrl}/adminservice/serviceprojectspace`,
      //projectRemoveUser: `${mainUrl}/adminservice/projectremoveuser`,
      projectRemoveUser: `${springUrl}/user/projectremoveuser`,
      projectRemoveHead: `${mainUrl}/adminservice/removeprojecthead`,
      hazardListByActivity: `${mainUrl}/adminservice/hazardlist`,
      generateQr: `${mainUrl}/adminservice/generateqr`,
      editQr: `${mainUrl}/adminservice/editqr`,
      validateQr: `${mainUrl}/adminservice/validateqrurl`,
    },
    modules: {
      moduleList: `${mainUrl}/adminservice/projectmodulelist`,
      activateModule: `${mainUrl}/adminservice/projectaddmodule`,
      deactivateModule: `${mainUrl}/adminservice/projectremovemodule`,
      activateAIModel: `${mainUrl}/adminservice/projectaddaimodel`,
      deactivateAIModel: `${mainUrl}/adminservice/projectremoveaimodel`,
      escalationLevelList: `${mainUrl}/adminservice/projectescalationlist`,
      springEscalationLevelwithUserList: `${stageUrl}/escalation/getEscalationLevelsWithUsers`,
      addEscalationLevel: `${mainUrl}/adminservice/projectescalationaddlevel`,
      springAddEscalationLevel: `${stageUrl}/escalation/addEscalationLevel`,
      springEditEscalationLevel: `${stageUrl}/escalation/updateEscalationLevel`,
      springDeleteEscalationLevel: `${stageUrl}/escalation/deleteEscalationLevel`,
      springAddonUserListForLevel: `${stageUrl}/escalation/getEscalationLevelUserList`,
      springRemoveUserForLevel: `${stageUrl}/escalation/deleteUserFromEscalation`,
      sprinaddUserForLevel: `${stageUrl}/escalation/addUsertoEscalation`,
      springGetEscalationMatrix: `${stageUrl}/escalation/getEscalationMatrix`,
      springUpdateEscalationMatrix: `${stageUrl}/escalation/escalationMatrix`,
      springGetEscalationLevels: `${stageUrl}/escalation/getEscalationLevels`,

      // Employee hierarchy based escalation (independent of stream / sub-stream, no users)
      springGetEmployeeHierarchyEscalationLevels: `${stageUrl}/escalation/getEmployeeHierarchyEscalationLevels`,
      springAddEmployeeHierarchyEscalationLevel: `${stageUrl}/escalation/addEmployeeHierarchyEscalationLevel`,
      springUpdateEmployeeHierarchyEscalationLevel: `${stageUrl}/escalation/updateEmployeeHierarchyEscalationLevel`,
      springDeleteEmployeeHierarchyEscalationLevel: `${stageUrl}/escalation/deleteEmployeeHierarchyEscalationLevel`,

      editEscalationLevel: `${mainUrl}/adminservice/projectescalationeditlevel`,
      deleteEscalationLevel: `${mainUrl}/adminservice/projectescalationdeletelevel`,
      addonUserListForLevel: `${mainUrl}/adminservice/projectescalationleveluserlistforaddition`,
      addUserForLevel: `${mainUrl}/adminservice/projectescalationleveladduser`,
      removeUserForLevel: `${mainUrl}/adminservice/projectescalationlevelremoveuser`,
      reportListNumber: `${mainUrl}/adminservice/projectreportnumber`,
      reportList: `${mainUrl}/adminservice/projectreportlist`,
      addReportUser: `${mainUrl}/adminservice/projectreportadduser`,
      removeReportUser: `${mainUrl}/adminservice/projectreportremoveuser`,
      addonReportUserList: `${mainUrl}/adminservice/projectreportuserlistforaddition`,
      closingRightList: `${mainUrl}/adminservice/projectcrlist`,
      zoneDepartmentFlag: `${stageUrl}/resolvingRights/checkAvailability`,
      closingRightPaginateDataList: `${mainUrl}/adminservice/projectcrlisttypewise`,
      addClosingRight: `${mainUrl}/adminservice/projectcrinitialresponse`,
      removeClosingRight: `${mainUrl}/adminservice/projectcrparameterdelete`,
      addonUserClosingRight: `${stageUrl}/resolvingRights/projectUserListForAdd`,
      addUserClosingRight: `${mainUrl}/adminservice/projectcradduser`,
      removeUserClosingRight: `${mainUrl}/adminservice/projectcrremoveuser`,
      projectContractorStatus: `${mainUrl}/adminservice/adminprojectconstatus`,
      resolvingRightsList: `${stageUrl}/resolvingRights/getResolvingRightsList`,
      resolvingRightsRefresh: `${stageUrl}/resolvingRights/refresh`,
      fetchModuleId: `${stageUrl}/escalation/getmoduleList`,
      addCategoryParameter: `${stageUrl}/resolvingRights/addCategoryParameter`,
      addCategorySelected: `${stageUrl}/resolvingRights/addCategorySelected`,
    },
    users: {
      projectUserNumber: `${mainUrl}/adminservice/projectusernumber`,
      searchUserList: `${mainUrl}/adminservice/searchadminuserlist`,
      searchUserListNew: `${stageUrl}/adminuser/list`,
      observerList: `${mainUrl}/adminservice/projectuserlistob`,
      observerListAllUsers: `${stageUrl}/service/projectuserlistforallusers`,
      projectHeadList: `${mainUrl}/adminservice/projectuserlistph`,
      projectHeadListAllUsers: `${stageUrl}/service/projectuserlistforallusers`,
      corporateList: `${mainUrl}/adminservice/projectuserlistcu`,
      corporateListAllUsers: `${stageUrl}/service/projectuserlistforallusers`,
      safetyHeadList: `${mainUrl}/adminservice/projectuserlistsh`,
      safetyHeadListAllUsers: `${stageUrl}/service/projectuserlistforallusers`,
      safetyTeamCompanyList: `${mainUrl}/adminservice/projectuserliststeamcu`,
      safetyTeamContractorList: `${mainUrl}/adminservice/projectuserliststeamch`,
      addUserFromList: `${mainUrl}/adminservice/projectadduserfromlist`,
      springAddUserFromList: `${stageUrl}/userMaster/addUserToProject`,
      addBulkUserFromList: `${mainUrl}/adminservice/bulkUserListAdd`,
      addContractorFromList: `${mainUrl}/adminservice/projectaddcontractortosafetyteam`,
      contractorUserList: `${mainUrl}/adminservice/projectcontractorlistforsafetyteam`,
      userListForAdd: `${mainUrl}/adminservice/projectuserlistforaddition`,
      userCategoryList: `${mainUrl}/adminservice/projectusercategorylist`,
      userCategoryAdd: `${mainUrl}/adminservice/projectusercategoryadd`,
      plantSafetyHeadList: `${mainUrl}/adminservice/projectuserlistpsh`,
      plantSafetyHeadListAllUsers: `${stageUrl}/service/projectuserlistforallusers`,
      reportingUserList: `${mainUrl}/adminservice/projectuserlistru`,
      reportingUserListAllUsers: `${stageUrl}/service/projectuserlistforallusers`,
    },
    hira: {
      activityList: `${mainUrl}/adminservice/projectactlist`,
      activityListForAdd: `${mainUrl}/adminservice/projectactlistforaddition`,
      addActivity: `${mainUrl}/adminservice/projectactadd`,
      deleteActivity: `${mainUrl}/adminservice/projectactremove`,
      barrierList: `${mainUrl}/adminservice/projectbarlist`,
      barrierListForAdd: `${mainUrl}/adminservice/projectbarlistforaddition`,
      addBarrier: `${mainUrl}/adminservice/projectbaradd`,
      deleteBarrier: `${mainUrl}/adminservice/projectbarremove`,
      hazardListForAdd: `${mainUrl}/adminservice/projecthazlistforaddition`,
      hazardList: `${mainUrl}/adminservice/projecthazlist`,
      addHazard: `${mainUrl}/adminservice/projecthazadd`,
      deleteHazard: `${mainUrl}/adminservice/projecthazremove`,
      subHazardList: `${mainUrl}/adminservice/projectsubhazlist`,
    },
    aialert: {
      aiAlertVoilation: `${mainUrl}/adminservice/get_ai_violations_alert`,
      aiRemark: `${mainUrl}/adminservice/set_ai_remark`,
      aiDashboard: `${mainUrl}/adminservice/ai_alert_dashboard`,
      aiNotDetect: `${mainUrl}/adminservice/modelwisegraph`,
      aiResolve: `${mainUrl}/adminservice/ai_alert_resolve`,
      aiAssignUser: `${mainUrl}/adminservice/ai_alert_closing_rigth_user_list`,
      aiAssignAddUser: `${mainUrl}/adminservice/set_ai_alert_closing_right`,
      aiCameraWise: `${mainUrl}/adminservice/get_cam_detail_by_user`,
      aiAlertByCameraHeading: `${mainUrl}/adminservice/getcameradetail`,
      aiAlertDelete: `${mainUrl}/adminservice/delete_ai_alert`,
      aiAlertDrillDown: `${mainUrl}/adminservice/ai_alert_drilldown`,
    },
    topic: {
      list: `${stageUrl}/topic/list`,
      addOrEdit: `${stageUrl}/topic/addEdit`,
      delete: `${stageUrl}/topic/delete`,
      export: `${stageUrl}/topic/export`,
      import: `${stageUrl}/topic/import`,
      restore: `${stageUrl}/topic/restore`,
    },
  },
  adminDashboard: {
    list: `${mainUrl}/admindashboard/list`,
    map: `${mainUrl}/adminmap/list`,
  },
  adminProfile: {
    adminProfileDetail: `${mainUrl}/adminprofile/list`,
    companyProfileDetail: `${mainUrl}/admincompany/list`,
    // companyProfileEdit: `${mainUrl}/admincompany/edit`,
    companyProfileEdit: `${stageUrl}/companyprofile/edit`,
    companyProfile: `${stageUrl}/companyprofile`,
    profileUpdate: `${stageUrl}/configurecompanysetting`,
  },
  configuration: {
    analytics: `${stageUrl}/configuration/getmodule`,
    analyticsUpdate: `${stageUrl}/configuration/updatemodule`,
  },
  adminSpace: {
    spaceDetail: `${mainUrl}/adminspace/space`,
    spaceInfo: `${mainUrl}/adminspace/space1`,
  },
  adminMaster: {
    contributingFactorList: `${mainUrl}/adminmodule/contributingFactorList`,
    springcontributingFactorList: `${stageUrl}/contributingFactor/list`,
    contributingFactorAdd: `${mainUrl}/adminmodule/contributingFactorAdd`,
    springcontributingFactorAdd: `${stageUrl}/contributingFactor/create`,
    contributingFactorEdit: `${mainUrl}/adminmodule/contributingFactorEdit`,
    springcontributingFactorEdit: `${stageUrl}/contributingFactor/update`,
    contributingFactorDelete: `${mainUrl}/adminmodule/contributingFactorDelete`,
    springcontributingFactorDelete: `${stageUrl}/contributingFactor/delete`,

    contributingFactorActivate: `${mainUrl}/adminmodule/contributingFactorActive`,
    springcontributingFactorActivate: `${stageUrl}/contributingFactor/restore`,
    importContributingFactor: `${mainUrl}/adminfactor/addcontributingfactorlist`,
    exportListCF: `${superadminAPI}/export/contributingfactorlist`,
    addExportListCF: `${mainUrl}/adminfactor/addcontributingfactorlist`,

    immediateFactorList: `${mainUrl}/adminmodule/immediateFactorList`,
    springimmediateFactorList: `${stageUrl}/immediateFactor/list`,
    immediateFactorAdd: `${mainUrl}/adminmodule/immediateFactorAdd`,
    springimmediateFactorAdd: `${stageUrl}/immediateFactor/create`,
    immediateFactorEdit: `${mainUrl}/adminmodule/immediateFactorEdit`,
    springimmediateFactorEdit: `${stageUrl}/immediateFactor/update`,
    immediateFactorDelete: `${mainUrl}/adminmodule/immediateFactorDelete`,
    springimmediateFactorDelete: `${stageUrl}/immediateFactor/delete`,
    immediateFactorActive: `${mainUrl}/adminmodule/immediateFactorActive`,
    springimmediateFactorActive: `${stageUrl}/immediateFactor/restore`,
    importImmediateFactor: `${mainUrl}/adminfactor/addimmediatefactorlist`,
    exportListIF: `${superadminAPI}/export/immediatefactorlist`,
    addExportListIF: `${mainUrl}/adminfactor/addimmediatefactorlist`,

    rootCauseFactorList: `${mainUrl}/adminmodule/rootcauseanalysisfactorList`,
    rootCauseFactorListNew: `${stageUrl}/rootCauseFactor/list`,

    rootCauseFactorEdit: `${mainUrl}/adminmodule/rootcauseanalysisfactoredit`,
    rootCauseFactorEditNew: `${stageUrl}/rootCauseFactor/update`,
    rootCauseFactorAdd: `${mainUrl}/adminmodule/rootcauseanalysisfactoradd`,
    rootCauseFactorAddNew: `${stageUrl}/rootCauseFactor/create`,
    rootCauseFactorDelete: `${mainUrl}/adminmodule/rootcauseanalysisfactordelete`,
    rootCauseFactorDeleteNew: `${stageUrl}/rootCauseFactor/delete`,
    rootCauseFactorActive: `${mainUrl}/adminmodule/rootcauseanalysisfactorActive`,
    importRootCauseFactor: `${mainUrl}/adminfactor/addrootcausefactorlist`,
    exportListRCF: `${superadminAPI}/export/rootcausefactorlist`,
    addExportListRCF: `${mainUrl}/adminfactor/addrootcausefactorlist`,
    rootCauseFactorRestoreNew: `${stageUrl}/rootCauseFactor/restore`,

    categoryList: `${mainUrl}/adminmodule/categoryList`,
    categoryListNew: `${stageUrl}/nmCategory/list`,
    categoryAddNew: `${stageUrl}/nmCategory/create`,
    categoryRestoreNew: `${stageUrl}/nmCategory/restore`,
    categoryEditNew: `${stageUrl}/nmCategory/update`,
    categoryDeleteNew: `${stageUrl}/nmCategory/delete`,
    categoryAdd: `${mainUrl}/adminmodule/categoryAdd`,
    categoryEdit: `${mainUrl}/adminmodule/categoryEdit`,
    categoryDelete: `${mainUrl}/adminmodule/categorydelete`,
    categoryActive: `${mainUrl}/adminmodule/categoryActive`,
    importCategory: `${mainUrl}/categoryfactor/addcategorymasterlist`,
    exportListCategory: `${superadminAPI}/export/categorymasterslist`,
    addExportListCategory: `${mainUrl}/categoryfactor/addcategorymasterlist`,
    adminCategoryList: `${mainUrl}/adminmodule/admincategoryList`,
  },
  adminPerformanceSetting: {
    getSettingData: `${mainUrl}/topperformer/tpdata`,
    updateSettingData: `${mainUrl}/topperformer/updateTpweightage`,
  },
  help: {
    helpList: `${mainUrl}/help/helplist`,
    helpUserList: `${mainUrl}/help/helpuserslist`,
    helpModuleList: `${mainUrl}/help/helpmoduleslist`,
    helpModuleListV1: `${mainUrl}/adminservice/projectmodulelist`,
  },
  tbt: {
    activityList: `${mainUrl}/tbt/activitytbtlist`,
    updateViewCount: `${mainUrl}/tbt/documnetViewCount`,
    addDocument: `${mainUrl}/tbt/adddocument`,
    documentList: `${mainUrl}/tbt/documentlist`,
    policyDocumentList: `${mainUrl}/tbt/tbtactivityanddocumentlist`,
    documentListSpring: `${springUrl}/documents`,
    addDocumentSpring: `${springUrl}/documents`,
    deleteDocumentSpring: `${springUrl}/documents`,
    deleteDocument: `${mainUrl}/tbt/deletedocument`,
    serviceProjectDocument: `${mainUrl}/tbt/serviceprojectdocument`,
    getSelectedServiceProject: `${mainUrl}/tbt/getselectedserviceproject`,
    serviceProjectMsdsDocument: `${mainUrl}/tbt/serviceprojectmsdsdocument`,
    fetchSelectedProjectActivity: `${mainUrl}/tbt/fetchselectedserviceprojectactivity`,
    fetchSelectedProjectDocument: `${mainUrl}/tbt/fetchselectedserviceprojectdocument`,
    tbtSettingData: `${stageUrl}/trainingTbt/getTBTSettingData`,
    tbtUpdatesavedformsettingSpring: `${stageUrl}/trainingTbt/editTBTSetting`,
  },
  goodPractices: {
    deleteGP: `${springUrl}/goodact/deletega`,
    gasavedformsetting: `${stageUrl}/ga/settingData`,
    gaupdatesavedformsetting: `${mainUrl}/project/gaformparameteredit`,
    gaupdatesavedformsettingSpring: `${stageUrl}/ga/editSettingData`,
    gpMasterList: `${mainUrl}/gamaster/list`,
    gpMasterAdd: `${mainUrl}/gamaster/add`,
    gpMasterEdit: `${mainUrl}/gamaster/edit`,
    gpMasterDelete: `${mainUrl}/gamaster/delete`,
    gpMasterActivate: `${mainUrl}/gamaster/reactivate`,
    addGoodPractice: `${springUrl}/goodact/goodactsreport`,
    externalAddGoodPractice: `${springUrl}/goodact/externalgoodactsreport`,
    categoryList: `${springUrl}/goodact/categorymasterslist`,
    gooPracticesList: `${springUrl}/goodact/goodactslist`,
    goodPractiseCount: `${springUrl}/goodact/goodactcount`,
    goodPracticesEdit: `${springUrl}/goodact/goodactsedit`,
    goodPractiseFilter: `${mainUrl}/listgoodacts/goodactfilter`,
    gpgraph: `${springUrl}/goodact/gagraph`,
    gpDetailById: `${springUrl}/goodact/gadetailbyid`,
    goodPracticeExcel: `${springUrl}/goodact/excelDownload`,
  },
  training: {
    trainingReport: `${springUrl}/training/trainingreport`,
    trainingList: `${springUrl}/training/traininglist`,
    deleteTraining: `${mainUrl}/training/deletetraining`,
    deleteTrainingNew: `${springUrl}/training/deletetraining`,
    trainingNumbers: `${springUrl}/training/trainingnumbers`,
    trainingtbtgendergraph: `${springUrl}/training/trainingtbtgendergraph`,
    tbtNumbers: `${springUrl}/training/tbtnumbers`,
    trainingEdit: `${springUrl}/training/trainingTbtEdit`,
    trainingFilter: `${springUrl}/training/trainingfilter`,
    updateStatus: `${springUrl}/training/updatetrainingstatus`,
    getTrainingById: `${springUrl}/training/gettrainingbyid`,
    getAssignPretest: `${springUrl}/training/assignpretestlist`,
    getTrainingAssignUserList: `${springUrl}/training/trainingassignuserlist`,
    addTrainingRights: `${springUrl}/training/addtrainingrights`,
    deleteTrainingRights: `${springUrl}/training/deletetrainingrights`,
    assignTrainingUser: `${mainUrl}/training/assigntraininguser`,
    assignTrainingUserNew: `${springUrl}/training/assigntraininguser`,
    trainingCount: `${springUrl}/training/trainingcount`,
    trainingListCalSort: `${springUrl}/training/traininglistcalsort`,
    trainingSettingData: `${stageUrl}/trainingTbt/getTrainingSettingData`,
    trainingUpdatesavedformsettingSpring: `${stageUrl}/trainingTbt/editTrainingSetting`,
    trainingExcel: `${springUrl}/training/excelDownload`,
  },
  iraMaster: {
    stepOne: {
      actionList: `${mainUrl}/irastep1/list`,
      actionAdd: `${mainUrl}/irastep1/add`,
      actionDelete: `${mainUrl}/irastep1/delete`,
      actionReactive: `${mainUrl}/irastep1/reactive`,
      actionImportList: `${superadminAPI}/export/actionparameterlist`,
      actionAddImport: `${mainUrl}/irastep1/actionparameterexportlistadd`,
      actionEdit: `${mainUrl}/irastep1/edit`,
    },
    stepTwo: {
      evidence: {
        evidenceList: `${mainUrl}/irastep2/listevidencecategory`,
        evidenceAdd: `${mainUrl}/irastep2/addevidencecategory`,
        evidenceDelete: `${mainUrl}/irastep2/deleteevidencecategory`,
        evidenceReactive: `${mainUrl}/irastep2/reactiveevidencecategory`,
        evidenceAddImport: `${mainUrl}/irastep2/evidencecategoryexportlistadd`,
        evidenceImportList: `${superadminAPI}/export/evidencecategorylist`,
        evidenceEdit: `${mainUrl}/irastep2/editevidencecategory`,
      },
      workType: {
        workTypeList: `${mainUrl}/irastep2/listworktype`,
        workTypeAdd: `${mainUrl}/irastep2/addworktype`,
        workTypeDelete: `${mainUrl}/irastep2/deleteworktype`,
        workTypeReactive: `${mainUrl}/irastep2/reactiveworktype`,
        workTypeAddImport: `${mainUrl}/irastep2/worktypeexportlistadd`,
        workTypeImportList: `${superadminAPI}/export/worktypelist`,
        editWorkType: `${mainUrl}/irastep2/editworktype`,
      },
      timeIncident: {
        timeIncidentList: `${mainUrl}/irastep2/listtimeofincident`,
        timeIncidentDelete: `${mainUrl}/irastep2/deletetimeofincident`,
        timeIncidentAdd: `${mainUrl}/irastep2/addtimeofincident`,
        timeIncidentReactive: `${mainUrl}/irastep2/reactivetimeofincident`,
        timeIncidentAddImport: `${mainUrl}/irastep2/timeofincidentexportlistadd`,
        timeIncidentImportList: `${superadminAPI}/export/timeofincidentlist`,
        editTimeOfIncident: `${mainUrl}/irastep2/edittimeofincident`,
      },
      injuredPart: {
        injuredPartList: `${mainUrl}/irastep2/listinjuredparts`,
        injuredPartDelete: `${mainUrl}/irastep2/deleteinjuredparts`,
        injuredPartAdd: `${mainUrl}/irastep2/addinjuredparts`,
        injuredPartReactive: `${mainUrl}/irastep2/reactiveinjuredparts`,
        injuredPartAddImport: `${mainUrl}/irastep2/injuredpartsexportlistadd`,
        injuredPartImportList: `${superadminAPI}/export/injuredpartslist`,
        editInjuredParts: `${mainUrl}/irastep2/editinjuredparts`,
      },
      workingShift: {
        workingShiftList: `${mainUrl}/irastep2/listworkingshift`,
        workingShiftAdd: `${mainUrl}/irastep2/addworkingshift`,
        workingShiftDelete: `${mainUrl}/irastep2/deleteworkingshift`,
        workingShiftReactivate: `${mainUrl}/irastep2/reactiveworkingshift`,
        workingShiftAddImport: `${mainUrl}/irastep2/workingshiftexportlistadd`,
        workingShiftImportList: `${superadminAPI}/export/workingshiftlist`,
        editWorkingShift: `${mainUrl}/irastep2/editworkingshift`,
      },
      incidentAnalysisQuestion: {
        questionList: `${mainUrl}/irastep2/listincidentanalysisquestion`,
        questionAdd: `${mainUrl}/irastep2/addincidentanalysisquestion`,
        questionDelete: `${mainUrl}/irastep2/deleteincidentanalysisquestion`,
        questionReactivate: `${mainUrl}/irastep2/reactiveincidentanalysisquestion`,
        questionAddImport: `${mainUrl}/irastep2/incidentanalysisquestionexportlistadd`,
        questionImportList: `${superadminAPI}/export/incidentanalysisquestionlist`,
        questionEdit: `${mainUrl}/irastep2/editincidentanalysisquestion`,
      },

      genderStepTwo: {
        genderListStepTwo: `${mainUrl}/irastep2/iragenderlist`,
      },

      injuryType: {
        injuryTypeList: `${mainUrl}/irastep2/irainjurytypelist`,
        injuryTypeAdd: `${mainUrl}/irastep2/addinjurytype`,
        injuryTypeDelete: `${mainUrl}/irastep2/deleteinjurytype`,
        injuryTypeEdit: `${mainUrl}/irastep2/editinjurytype`,
        injuryTypeRestore: `${mainUrl}/irastep2/reactiveinjureytype`,
      },
    },
    stepThree: {
      otherInfo: {
        list: `${mainUrl}/irastep3/list`,
        add: `${mainUrl}/irastep3/add`,
        delete: `${mainUrl}/irastep3/delete`,
        reactive: `${mainUrl}/irastep3/reactive`,
        addImport: `${mainUrl}/irastep3/otherinfoexportlistadd`,
        importList: `${superadminAPI}/export/otherinfolist`,
        edit: `${mainUrl}/irastep3/edit`,
      },
      returnToWork: {
        returnToWorkList: `${mainUrl}/irastep3/returntoworklist`,
        returnToWorkAdd: `${mainUrl}/irastep3/addreturntoworkinfo`,
        returnToWorkEdit: `${mainUrl}/irastep3/editreturntoworkinfo`,
        returnToWorkDelete: `${mainUrl}/irastep3/deletereturntowork`,
        returnToWorkRestore: `${mainUrl}/irastep3/reactivereturntowork`,
      },
      FiveAnalysis: {
        tabList: `${mainUrl}/irastep3/fivemanalysislist`,
        add: `${mainUrl}/irastep3/addfivemanalysisinfo`,
        delete: `${mainUrl}/irastep3/fivemanalysisdelete`,
        edit: `${mainUrl}/irastep3/fivemanalysisedit`,
        reActive: `${mainUrl}/irastep3/fivemanalysisReactive`,
      },
    },
    stepFour: {
      mainCategory: {
        list: `${mainUrl}/irastep4/maincategorylist`,
        add: `${mainUrl}/irastep4/maincategoryadd`,
        delete: `${mainUrl}/irastep4/maincategorydelete`,
        reactive: `${mainUrl}/irastep4/maincategoryreactive`,
        addImport: `${mainUrl}/irastep4/cfcategoryexportlistadd`,
        importList: `${superadminAPI}/export/cfcategorylist`,
        edit: `${mainUrl}/irastep4/maincategoryedit`,
      },
      subCategory: {
        list: `${mainUrl}/irastep4/subcategorylist`,
        add: `${mainUrl}/irastep4/subcategoryadd`,
        delete: `${mainUrl}/irastep4/subcategorydelete`,
        reactive: `${mainUrl}/irastep4/subcategoryreactive`,
        edit: `${mainUrl}/irastep4/subcategoryedit`,
      },
      majorCategoryUrl: {
        list: `${mainUrl}/irastep4/majorcategorylist`,
        add: `${mainUrl}/irastep4/majorcategoryadd`,
        delete: `${mainUrl}/irastep4/majorcategorydelete`,
        reactive: `${mainUrl}/irastep4/majorcategoryreactive`,
        edit: `${mainUrl}/irastep4/majorcategoryedit`,
      },
      nearCategoryUrl: {
        list: `${mainUrl}/irastep4/nearcategorylist`,
        add: `${mainUrl}/irastep4/nearcategoryadd`,
        delete: `${mainUrl}/irastep4/nearcategorydelete`,
        reactive: `${mainUrl}/irastep4/nearcategoryreactive`,
        edit: `${mainUrl}/irastep4/nearcategoryedit`,
      },
      intermediateCategory: {
        list: `${mainUrl}/irastep4/intermediatecategorylist`,
        add: `${mainUrl}/irastep4/intermediatecategoryadd`,
        delete: `${mainUrl}/irastep4/intermediatecategorydelete`,
        reactive: `${mainUrl}/irastep4/intermediatecategoryreactive`,
        edit: `${mainUrl}/irastep4/intermediatecategoryedit`,
      },
      rootCauseType: {
        list: `${mainUrl}/irastep4/rootcausetypelist`,
        add: `${mainUrl}/irastep4/rctypecategoryadd`,
        delete: `${mainUrl}/irastep4/rctypecategorydelete`,
        reactive: `${mainUrl}/irastep4/rctypecategoryreactive`,
        addImport: `${mainUrl}/irastep4/cfrootcausecategoryexportlistadd`,
        importList: `${superadminAPI}/export/cfrootcausecategorylist`,
        edit: `${mainUrl}/irastep4/rctypecategoryedit`,
      },
      rootCause: {
        list: `${mainUrl}/irastep4/rootcauselist`,
        add: `${mainUrl}/irastep4/rccategoryadd`,
        delete: `${mainUrl}/irastep4/rccategorydelete`,
        reactive: `${mainUrl}/irastep4/rccategoryreactive`,
        edit: `${mainUrl}/irastep4/rccategoryedit`,
      },
    },
    stepFive: {
      category: {
        list: `${mainUrl}/adminmodule/categoryList`,
      },
    },
  },
  reporting: {
    ira: {
      viewreport: `${mainUrl}/listira/iraviewpdf`,
    },
    nm: {
      viewreport: `${mainUrl}/listnm/nmpdfview`,
    },
  },
  safetymanhrs: {
    manhours: `${springUrl}/safetyman/addeditsafetymanhours`,
    safetyManHoursRightList: `${springUrl}/safetyman/hoursrightlist`,
    addSafetyManHoursRights: `${springUrl}/safetyman/addsafetymanhoursrights`,
    deleteSafetyManHoursRight: `${springUrl}/safetyman/deleteHoursRights`,
    checkSafetyManHoursRights: `${springUrl}/safetyman/checkSafetyManHoursRights`,
    monthWiseHoursCount: `${springUrl}/safetyman/monthwisehourscount`,
    getSafetyManHours: `${springUrl}/safetyman/getsafetymanhours`,
    editSafeManHoursValue: `${springUrl}/safetyman/editsafemanhoursvalue`,
    getLocationWiseSafeManHours: `${springUrl}/safetyman/getlocationwisesafemanhours`,
    getMonthWiseSafeManHoursCount: `${springUrl}/safetyman/getmonthwisesafemanhourscount`,
    monthWiseCountSpring: `${springUrl}/safetyman/monthwisecount`,
    checkSafeManHours: `${springUrl}/safetyman/checksafemanhours`,
    changesafemanhoursmonth: `${springUrl}/safetyman/changesafemanhoursmonth`,
  },
  safetyMeeting: {
    addSafetyMeetingSpring: `${springUrl}/safetymeeting/addsafetymeeting`,
    editSafetyMeeting: `${mainUrl}/safetymeeting/editsafetymeeting`,
    safetyMeetingRightList: `${springUrl}/safetymeeting/safetymeetingrightlist`,
    safetyMeetingInviteUserList: `${springUrl}/safetymeeting/safetyMeetinginviteuserlist`,
    addSafetyMeetingRights: `${springUrl}/safetymeeting/addsafetymeetingrights`,
    deleteSafetyMeetingRights: `${springUrl}/safetymeeting/deletesafetymeetingrights`,
    checkSafetyMeetingRights: `${mainUrl}/safetymeeting/checksafetymeetingrights`,
    safetyMeetingDetailsSpring: `${springUrl}/safetymeeting/safetymeetingdetails`,
    safetyMeetingListSpring: `${springUrl}/safetymeeting/safetymeetinglist`,
    // saveSafetyMeetingRecommendation: `${mainUrl}/safetymeeting/savesafetymeetingrecommendation`,
    safetyMeetingRecommendationList: `${springUrl}/safetymeeting/safetymeetingrecommendationlist`,
    safetyMeetingCount: `${springUrl}/safetymeeting/safetymeetingcount`,
    safetyMeetingGraph: `${springUrl}/safetymeeting/safetymeetinggraph`,
    deleteSafetyMeeting: `${springUrl}/safetymeeting/deletesafetymeeting`,
    safetyMeetingStatusChange: `${mainUrl}/safetymeeting/safetymeetingstatuschange`,
    changeStartDate: `${mainUrl}/safetymeeting/updatestartdate`,
    changeEndDate: `${mainUrl}/safetymeeting/updateenddate`,
    deleteOtherInviteUser: `${mainUrl}/safetymeeting/deleteotherinviteuser`,
    addRecommendation: `${springUrl}/safetymeeting/saverecommendation`,
    recommendationEdit: `${springUrl}/safetymeeting/editrecommendation`,
    recommendationDelete: `${springUrl}/safetymeeting/deleterecommendation`,
    safetyRecTotalCount: `${springUrl}/safetymeeting/safetydbcount`,
    allOtherUserSmData: `${springUrl}/safetymeeting/allotherusersafetymeetingdata`,
    allOtherUserSmCount: `${springUrl}/safetymeeting/allotherusersmcount`,
  },
  polling: {
    pollingReport: `${springUrl}/poll/report`,
    pollingPlan: `${springUrl}/poll/planreport`,
    pollingList: `${springUrl}/poll/pollingList`,
    editPollingReport: `${springUrl}/poll/editreport`,
    deletePoll: `${springUrl}/poll/delete`,
    activePoll: `${springUrl}/poll/activepoll`,
    savePollResponse: `${springUrl}/poll/saveresponse`,
    pollcategorylist: `${mainUrl}/polling/pollcategorylist`,
    pollgraphs: `${springUrl}/poll/pollgraph`,
    pollingById: `${springUrl}/poll/pollbyid`,
    // pollingById: `${mainUrl}/polling/pollingbyid`,
    editPollFile: `${mainUrl}/polling/editpollfile`,
    getExternalPollingById: `${springUrl}/poll/listExternal`,
    submitExternalPollResponse: `${springUrl}/poll/externalresponse`,
  },
  formTypeGraph: {
    auditRecommendation: `${mainUrl}/task/auditrecommendationlist`,
    graph: `${mainUrl}/formtypegraph/graph`,
    workpermitlistgraph: `${mainUrl}/formtypegraph/workpermitlistgraph`,
    surveygraph: `${mainUrl}/surveygraph/surveylistgraph`,
    formTypeCount: `${mainUrl}/formtypegraph/formtypecount`,
    surveyListCount: `${mainUrl}/formtypegraph/surveylistcount`,
    workPermitCount: `${mainUrl}/formtypegraph/workpermitcount`,
    templateListCount: `${mainUrl}/formtypegraph/templatelistcount`,
    dataCollectionGraph: `${mainUrl}/formtypegraph/datacollectiongraph`,
    bbsgraph: `${mainUrl}/formtypegraph/bbsgraph`,
    formcounts: `${mainUrl}/formtypegraph/formcounts`,
    elearningCount: `${mainUrl}/formtypegraph/elearninglistcount`,
    dbAvgPerCompliance: `${mainUrl}/formtypegraph/dbavgpercompliance`,
  },
  costing: {
    costingList: `${mainUrl}/costing/formcostingList`,
    updateCosting: `${mainUrl}/costing/updatecosting`,
    costingmonthwisecount: `${mainUrl}/costing/costingmonthwisecount`,
  },
  // taskManagement: {
  //   task: `${mainUrl}/task/task`,
  //   allTaskList: `${mainUrl}/task/alltasklist`,
  //   taskList: `${mainUrl}/task/tasklist`,
  //   taskReport: `${mainUrl}/task/taskreport`,
  //   changeStatus: `${mainUrl}/task/changestatus`,
  //   taskDelete: `${mainUrl}/task/taskdelete`,
  //   taskGraph: `${mainUrl}/task/taskgraph`,
  //   taskEdit: `${mainUrl}/task/taskedit`,
  //   todayTaskData: `${mainUrl}/task/todaytaskdata`,
  //   recommendationList: `${mainUrl}/task/recommendationlist`,
  //   taskCommentList: `${mainUrl}/task/taskcommentlist`,
  //   taskContentAddLikeToComment: `${mainUrl}/task/taskcontentaddliketocomment`,
  //   taskcontentcommentremoveunlike: `${mainUrl}/task/taskcontentcommentremoveunlike`,
  //   taskContentAddSubcomment: `${mainUrl}/task/taskcontentaddsubcomment`,
  //   taskDetailCommentSubcommentlist: `${mainUrl}/task/taskdetailcommentsubcommentlist`,
  //   taskdeletecomment: `${mainUrl}/task/taskdeletecomment`,
  //   taskcontentaddcomment: `${mainUrl}/task/taskcontentaddcomment`,
  //   taskAddDocument: `${mainUrl}/task/taskadddocument`,
  //   deleteUrlLink: `${mainUrl}/task/deleteurllink`,
  //   allTaskListCount: `${mainUrl}/task/alltasklistcount`,
  // },
  taskManagement: {
    task: `${springUrl}/task/task`,
    allTaskList: `${springUrl}/task/alllist`,
    taskList: `${springUrl}/task/alllist`,
    taskReport: `${springUrl}/task/report`,
    changeStatus: `${springUrl}/task/changestatus`,
    taskDelete: `${springUrl}/task/delete`,
    taskGraph: `${springUrl}/task/graph`,
    taskEdit: `${springUrl}/task/edit`,
    taskcontentaddcomment: `${springUrl}/task/addcomment`,
    allTaskListCount: `${springUrl}/task/alllistcount`,
    taskCommentList: `${springUrl}/task/commentlist`,
    taskdeletecomment: `${springUrl}/task/deletecomment`,
    taskAddDocument: `${springUrl}/task/addDocument`,
    deleteUrlLink: `${springUrl}/task/deleteurl`,

    todayTaskData: `${mainUrl}/task/todaytaskdata`,
    recommendationList: `${mainUrl}/task/recommendationlist`,
    taskContentAddLikeToComment: `${mainUrl}/task/taskcontentaddliketocomment`,
    taskcontentcommentremoveunlike: `${mainUrl}/task/taskcontentcommentremoveunlike`,
    taskContentAddSubcomment: `${mainUrl}/task/taskcontentaddsubcomment`,
    taskDetailCommentSubcommentlist: `${mainUrl}/task/taskdetailcommentsubcommentlist`,
    // taskcontentaddcomment: `${mainUrl}/task/taskcontentaddcomment`,
  },
  // goal: {
  //   goal: `${mainUrl}/goal/goal`,
  //   goalReport: `${mainUrl}/goal/goalreport`,
  //   goalList: `${mainUrl}/goal/goallist`,
  //   changeStatus: `${mainUrl}/goal/changestatus`,
  //   goalDelete: `${mainUrl}/goal/goaldelete`,
  //   inactiveDeletedGoalList: `${mainUrl}/goal/inactivedeletedgoallist`,
  //   goalGraph: `${mainUrl}/goal/goalgraph`,
  //   tabsCount: `${mainUrl}/goal/tabscount`,
  //   goalEdit: `${mainUrl}/goal/goaledit`,
  //   goalEditTask: `${mainUrl}/goal/goaledittask`,
  // },
  goal: {
    goal: `${springUrl}/goal/goal`,
    goalReport: `${springUrl}/goal/report`,
    goalList: `${springUrl}/goal/list`,
    changeStatus: `${springUrl}/goal/changestatus`,
    goalDelete: `${springUrl}/goal/delete`,
    inactiveDeletedGoalList: `${springUrl}/goal/inactivedeletedlist`,
    goalGraph: `${springUrl}/goal/graph`,
    tabsCount: `${springUrl}/goal/tabscount`,
    goalEdit: `${springUrl}/goal/edit`,
  },
  external: {
    externalMarketPlace: `${mainUrl}/external/externalmarketplace`,
    externalDocumentList: `${mainUrl}/external/externaldocumentlist`,
    externalmarketplacefilter: `${mainUrl}/external/externalmarketplacefilter`,
    externalUserFormDetails: `${mainUrl}/external/externaluserformdetails`,
    externalUserResponse: `${mainUrl}/external/externaluserresponse`,
    externalSurveyGraph: `${mainUrl}/external/externalsurveygraph`,
    surveyStatus: `${mainUrl}/external/surveystatus`,
    externalMarketplaceKeySearch: `${mainUrl}/external/externalmarketplacefiltersearch`,
  },
  documentCategory: {
    categoryList: `${stageUrl}/documentMaster/categoryList`,
    addDocumentCategory: `${stageUrl}/documentMaster/addDocumentCategory`,
    updateCategory: `${stageUrl}/documentMaster/updateCategory`,
    deleteCategory: `${stageUrl}/documentMaster/deleteDocumentCategory`,
    getAttachments: `${springUrl}/document/list`,
    addAttachment: `${springUrl}/document/addAttachment`,
    deleteAttachment: `${springUrl}/document/delete`,
  },

  observations: {
    evidence: `${nodeUrl}/observations/:id/evidence`,
    raisedBy: `${nodeUrl}/observation/:id/raised-by`,
    servicePlant: `${nodeUrl}/observations/:id/service-plant`,
    targetDate: `${nodeUrl}/observations/:id/target-date`,
    budget: `${nodeUrl}/observations/:id/budget`,
    budgetDetails: `${nodeUrl}/observations/:id/budget-details`,
    timeline: `${nodeUrl}/timeline/observation/:id`,
    raisedOn: `${nodeUrl}/observations/:id/raised-on`,
    responsiblePerson: `${nodeUrl}/observation/:id/responsible-person`,
    locationInfo: `${nodeUrl}/observations/:id/location-info`,
    auditDetails: `${nodeUrl}/observations/:id/audit-details`,
    approve: `${nodeUrl}/:id/approve`,
    reject: `${nodeUrl}/:id/reject`,
    submit: `${nodeUrl}/observations/:id/submit`,
    submitDetails: `${nodeUrl}/observations/:id/submit-details`,
    userRightsList: `${springUrl}/master/userRightsList`,
    addUserRights: `${springUrl}/master/addUserRights`,
    deleteUserRights: `${springUrl}/master/deleteUserRights`,
    getAssignUserList: `${springUrl}/master/userRightsList`,
    addRights: `${springUrl}/master/addUserRights`,
    deleteRights: `${springUrl}/master/deleteUserRights`,
    userRightsList: `${springUrl}/master/userRightsList`,
    addUserRights: `${springUrl}/master/addUserRights`,
    deleteUserRights: `${springUrl}/master/deleteUserRights`,
    // Mail configuration — POST to fetch, PUT to save. Body: { moduleName: "OBSERVATION", ... }
    mailConfiguration: `${stageUrl}/module/mailConfiguration`,
  },

  observationRecommendation: {
    add: `${nodeUrl}/observation-recommendation`,
    delete: (id) => `${nodeUrl}/observation-recommendation/${id}`,
    list: (id) => `${nodeUrl}/observation-recommendation/observation/${id}`,
    actionTaken: (id) =>
      `${nodeUrl}/observation-recommendation/${id}/action-taken`,
  },

  createSection: (id) => `${nodeUrl}/legal-register/${id}/create-section`,
  getSections: (auditNo) => `${nodeUrl}/legal-register/${auditNo}/sections`,
  submitForm: (auditNo) =>
    `${nodeUrl}/legal-register/${auditNo}/create-section/submit-form`,
  getFormSections: (auditNo) =>
    `${nodeUrl}/legal-register/${auditNo}/create-section/form`,
  getById: (auditNo) => `${nodeUrl}/legal-register/${auditNo}`,
  saveDraft: (auditNo) =>
    `${nodeUrl}/legal-register/${auditNo}/create-section/draft`,

  legalRegister: {
    add: `${nodeUrl}/legal-register`,
    filter: `${nodeUrl}/legal-register/list`,
    dashboard: `${nodeUrl}/legal-register/dashboard`,
    assignedList: `${nodeUrl}/legal-register/assigned/list`,
    createSection: (id) => `${nodeUrl}/legal-register/${id}/create-section`,
    getSections: (auditNo) => `${nodeUrl}/legal-register/${auditNo}/sections`,
    submitForm: (auditNo) =>
      `${nodeUrl}/legal-register/${auditNo}/create-section/submit-form`,
    getFormSections: (auditNo) =>
      `${nodeUrl}/legal-register/${auditNo}/create-section/form`,
    getById: (auditNo) => `${nodeUrl}/legal-register/${auditNo}`,
    saveDraft: (auditNo) =>
      `${nodeUrl}/legal-register/${auditNo}/create-section/draft`,
    getRowDocuments: (auditNo, sectionId, rowId) =>
      `${nodeUrl}/legal-register/${auditNo}/create-section/${sectionId}/rows/${rowId}/documents`,
    uploadRowDocuments: (auditNo, sectionId, rowId) =>
      `${nodeUrl}/legal-register/${auditNo}/create-section/${sectionId}/rows/${rowId}/upload-documents`,
    // userRightsList: `${springUrl}/master/userRightsList`,
    // addRights: `${springUrl}/master/addUserRights`,
    // deleteRights: `${springUrl}/master/deleteUserRights`,
    // getAssignUserList: `${springUrl}/master/userRightsList`,
    // addRights: `${springUrl}/master/addUserRights`,
    // deleteRights: `${springUrl}/master/deleteUserRights`,
    ruleMasterAdd: `${nodeUrl}/legal-register/rule-master`,
    ruleMasterList: `${nodeUrl}/legal-register/rule-master/list`,
    frequencyMasterAdd: `${nodeUrl}/legal-register/frequency-master`,
    frequencyMasterList: `${nodeUrl}/legal-register/frequency-master/list`,
    mailConfig: `${nodeUrl}/mailConfig`,

    // Documents
    getRowDocuments: (auditNo, sectionId, rowId) =>
      `${nodeUrl}/legal-register/${auditNo}/create-section/${sectionId}/rows/${rowId}/documents`,
    uploadRowDocuments: (auditNo, sectionId, rowId) =>
      `${nodeUrl}/legal-register/${auditNo}/create-section/${sectionId}/rows/${rowId}/upload-documents`,
    deleteRowDocument: (auditNo, sectionId, rowId, documentId) =>
      `${nodeUrl}/legal-register/${auditNo}/create-section/${sectionId}/rows/${rowId}/documents/${documentId}`,

    // User Rights
    userRightsList: `${springUrl}/template/accessList`,
    getAssignUserList: `${springUrl}/template/accessList`,
    addRights: `${springUrl}/template/grantAccess`,
    deleteRights: `${springUrl}/template/revokeAccess`,
    addUserRights: `${springUrl}/template/grantAccess`,
    deleteUserRights: `${springUrl}/template/revokeAccess`,
    // User Rights
    // userRightsList: `${springUrl}/master/userRightsList`,
    // getAssignUserList: `${springUrl}/master/userRightsList`,
    // addRights: `${springUrl}/master/addUserRights`,
    // deleteRights: `${springUrl}/master/deleteUserRights`,
    // addUserRights: `${springUrl}/master/addUserRights`,
    // deleteUserRights: `${springUrl}/master/deleteUserRights`,

    // Rule Master
    ruleMasterAdd: `${nodeUrl}/legal-register/rule-master`,
    ruleMasterList: `${nodeUrl}/legal-register/rule-master/list`,
    ruleMasterUpload: `${nodeUrl}/legal-register/rule-master/upload`,
    ruleMasterSampleDownload: `${nodeUrl}/legal-register/rule-master/sample-download`,
    ruleMasterUpdate: (id) => `${nodeUrl}/legal-register/rule-master/${id}`,
    ruleMasterDelete: (id) => `${nodeUrl}/legal-register/rule-master/${id}`,
    ruleMasterRestore: (id) =>
      `${nodeUrl}/legal-register/rule-master/${id}/restore`,

    // Frequency Master
    frequencyMasterAdd: `${nodeUrl}/legal-register/frequency-master`,
    frequencyMasterList: `${nodeUrl}/legal-register/frequency-master/list`,
    frequencyMasterUpload: `${nodeUrl}/legal-register/frequency-master/upload`,
    frequencyMasterSampleDownload: `${nodeUrl}/legal-register/frequency-master/sample-download`,
    frequencyMasterUpdate: (id) =>
      `${nodeUrl}/legal-register/frequency-master/${id}`,
    frequencyMasterDelete: (id) =>
      `${nodeUrl}/legal-register/frequency-master/${id}`,
    frequencyMasterRestore: (id) =>
      `${nodeUrl}/legal-register/frequency-master/${id}/restore`,

    // Legal Register Bulk Upload
    registerUpload: `${nodeUrl}/legal-register/upload`,
    registerSampleDownload: `${nodeUrl}/legal-register/sample-download`,

    // Assign
    assign: (id) => `${nodeUrl}/legal-register/${id}/assign`,

    // Mail Configuration
    mailConfig: `${nodeUrl}/legal-register/mail-config`,
    sendMail: (auditNo) => `${nodeUrl}/legal-register/${auditNo}/send-mail`,
    // Update
    update: (id) => `${nodeUrl}/legal-register/${id}`,
    // Soft Delete
    delete: (id) => `${nodeUrl}/legal-register/${id}`,

    // Settings
    settings: `${nodeUrl}/legal-register/settings`,
    settingsReportingParameter: `${nodeUrl}/legal-register/settings/reporting-parameter`,
    settingsSectionWiseEvidenceDocument: `${nodeUrl}/legal-register/settings/section-wise-evidence-document`,
    settingsSupportingDocument: `${nodeUrl}/legal-register/settings/supporting-document`,
    settingsSupportingDocumentDelete: (docId) =>
      `${nodeUrl}/legal-register/settings/supporting-document/${docId}`,
    settingsSupportingDocumentEnabled: `${nodeUrl}/legal-register/settings/supporting-document-enabled`,
    settingsEscalation: `${nodeUrl}/legal-register/settings/escalation`,
    settingsFormCreation: `${nodeUrl}/legal-register/settings/form-creation`,
    settingsFormAssignFunctionality: `${nodeUrl}/legal-register/settings/form-assign-functionality`,
    settingsAllowedFileTypes: `${nodeUrl}/legal-register/settings/allowed-file-types`,
  },
  brsr: {
    dashboard: `${nodeUrl}/brsr/dashboard`,
    template: `${nodeUrl}/brsr/template`,
    templateFields: `${nodeUrl}/brsr/template/fields`,
    derivedSources: `${nodeUrl}/brsr/derived-sources`,
    derivedValue: `${nodeUrl}/brsr/derived-value`,
    reports: `${nodeUrl}/brsr/reports`,
    reportDetails: (id) => `${nodeUrl}/brsr/reports/${id}`,
    submit: (id) => `${nodeUrl}/brsr/reports/${id}/submit`,
    approve: (id) => `${nodeUrl}/brsr/reports/${id}/approve`,
    progress: (id) => `${nodeUrl}/brsr/reports/${id}/progress`,
    sectionA: (id) => `${nodeUrl}/brsr/reports/${id}/section-a`,
    sectionB: (id) => `${nodeUrl}/brsr/reports/${id}/section-b`,
    sectionC: (id) => `${nodeUrl}/brsr/reports/${id}/section-c`,
    values: (id) => `${nodeUrl}/brsr/reports/${id}/values`,
    upsertValues: (id) => `${nodeUrl}/brsr/reports/${id}/values`,
    upsertValuesBatch: (id) => `${nodeUrl}/brsr/reports/${id}/values/batch`,
    evidencePresign: (id) => `${nodeUrl}/brsr/reports/${id}/evidence/presign`,
    evidenceConfirm: (id) => `${nodeUrl}/brsr/reports/${id}/evidence/confirm`,
    listEvidence: (id) => `${nodeUrl}/brsr/reports/${id}/evidence`,
    deleteEvidence: (id) => `${nodeUrl}/brsr/evidence/${id}`,
  },
  esg: {
    list: `${springUrl}/esg/masters`,
    addSubMaster: `${springUrl}/esg/sub-master/saveOrUpdate`,
    addMonthlyData: `${springUrl}/esg/sub-master/values`,
    subMasterList: `${springUrl}/esg/sub-masters/list`,
    monthly: `${springUrl}/esg/sub-masters/year`,
    addToScope: `${springUrl}/esg/sub-master/add-to-scope`,
    scopeData: `${springUrl}/esg/sub-masters/scope`,
    // Category CRUD
    categoryList: `${springUrl}/esg/categories/list`,
    categorySaveOrUpdate: `${springUrl}/esg/category/saveOrUpdate`,
    categoryById: `${springUrl}/esg/category`,
    categoryDelete: `${springUrl}/esg/category/delete`,
    categoryRetrieve: `${springUrl}/esg/category/retrieve`,
  },

  common: {
    checkModuleRights: `${springUrl}/clide/checkModuleRights`,
  },
  master: {
    userRightsList: `${springUrl}/master/userRightsList`,
    addUserRights: `${springUrl}/master/addUserRights`,
    deleteUserRights: `${springUrl}/master/deleteUserRights`,
    checkModuleRights: `${springUrl}/clide/checkModuleRights`,
  },
  workPermit: {
    checkModuleRights: `${springUrl}/clide/checkModuleRights`,
    userRightsList: `${springUrl}/master/userRightsList`,
    addUserRights: `${springUrl}/master/addUserRights`,
    deleteUserRights: `${springUrl}/master/deleteUserRights`,
  },
};

export default urls;
